"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (f) {
    if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
        module.exports = f();
    } else if (typeof define === "function" && define.amd) {
        define([], f);
    } else {
        var g;if (typeof window !== "undefined") {
            g = window;
        } else if (typeof global !== "undefined") {
            g = global;
        } else if (typeof self !== "undefined") {
            g = self;
        } else {
            g = this;
        }g.LinkMapper = f();
    }
})(function () {
    var define, module, exports;return function () {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                    }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                        var n = e[i][1][r];return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }return n[i].exports;
            }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
                o(t[i]);
            }return o;
        }return r;
    }()({ 1: [function (require, module, exports) {}, {}], 2: [function (require, module, exports) {
            'use strict';

            var GetIntrinsic = require('get-intrinsic');

            var callBind = require('./');

            var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

            module.exports = function callBoundIntrinsic(name, allowMissing) {
                var intrinsic = GetIntrinsic(name, !!allowMissing);
                if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
                    return callBind(intrinsic);
                }
                return intrinsic;
            };
        }, { "./": 3, "get-intrinsic": 15 }], 3: [function (require, module, exports) {
            'use strict';

            var bind = require('function-bind');
            var GetIntrinsic = require('get-intrinsic');
            var setFunctionLength = require('set-function-length');

            var $TypeError = require('es-errors/type');
            var $apply = GetIntrinsic('%Function.prototype.apply%');
            var $call = GetIntrinsic('%Function.prototype.call%');
            var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

            var $defineProperty = require('es-define-property');
            var $max = GetIntrinsic('%Math.max%');

            module.exports = function callBind(originalFunction) {
                if (typeof originalFunction !== 'function') {
                    throw new $TypeError('a function is required');
                }
                var func = $reflectApply(bind, $call, arguments);
                return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
            };

            var applyBind = function applyBind() {
                return $reflectApply(bind, $apply, arguments);
            };

            if ($defineProperty) {
                $defineProperty(module.exports, 'apply', { value: applyBind });
            } else {
                module.exports.apply = applyBind;
            }
        }, { "es-define-property": 5, "es-errors/type": 11, "function-bind": 14, "get-intrinsic": 15, "set-function-length": 29 }], 4: [function (require, module, exports) {
            'use strict';

            var $defineProperty = require('es-define-property');

            var $SyntaxError = require('es-errors/syntax');
            var $TypeError = require('es-errors/type');

            var gopd = require('gopd');

            /** @type {import('.')} */
            module.exports = function defineDataProperty(obj, property, value) {
                if (!obj || (typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== 'object' && typeof obj !== 'function') {
                    throw new $TypeError('`obj` must be an object or a function`');
                }
                if (typeof property !== 'string' && (typeof property === "undefined" ? "undefined" : _typeof(property)) !== 'symbol') {
                    throw new $TypeError('`property` must be a string or a symbol`');
                }
                if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
                    throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
                }
                if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
                    throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
                }
                if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
                    throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
                }
                if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
                    throw new $TypeError('`loose`, if provided, must be a boolean');
                }

                var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
                var nonWritable = arguments.length > 4 ? arguments[4] : null;
                var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
                var loose = arguments.length > 6 ? arguments[6] : false;

                /* @type {false | TypedPropertyDescriptor<unknown>} */
                var desc = !!gopd && gopd(obj, property);

                if ($defineProperty) {
                    $defineProperty(obj, property, {
                        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
                        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
                        value: value,
                        writable: nonWritable === null && desc ? desc.writable : !nonWritable
                    });
                } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
                    // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
                    obj[property] = value; // eslint-disable-line no-param-reassign
                } else {
                    throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
                }
            };
        }, { "es-define-property": 5, "es-errors/syntax": 10, "es-errors/type": 11, "gopd": 16 }], 5: [function (require, module, exports) {
            'use strict';

            var GetIntrinsic = require('get-intrinsic');

            /** @type {import('.')} */
            var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
            if ($defineProperty) {
                try {
                    $defineProperty({}, 'a', { value: 1 });
                } catch (e) {
                    // IE 8 has a broken defineProperty
                    $defineProperty = false;
                }
            }

            module.exports = $defineProperty;
        }, { "get-intrinsic": 15 }], 6: [function (require, module, exports) {
            'use strict';

            /** @type {import('./eval')} */

            module.exports = EvalError;
        }, {}], 7: [function (require, module, exports) {
            'use strict';

            /** @type {import('.')} */

            module.exports = Error;
        }, {}], 8: [function (require, module, exports) {
            'use strict';

            /** @type {import('./range')} */

            module.exports = RangeError;
        }, {}], 9: [function (require, module, exports) {
            'use strict';

            /** @type {import('./ref')} */

            module.exports = ReferenceError;
        }, {}], 10: [function (require, module, exports) {
            'use strict';

            /** @type {import('./syntax')} */

            module.exports = SyntaxError;
        }, {}], 11: [function (require, module, exports) {
            'use strict';

            /** @type {import('./type')} */

            module.exports = TypeError;
        }, {}], 12: [function (require, module, exports) {
            'use strict';

            /** @type {import('./uri')} */

            module.exports = URIError;
        }, {}], 13: [function (require, module, exports) {
            'use strict';

            /* eslint no-invalid-this: 1 */

            var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
            var toStr = Object.prototype.toString;
            var max = Math.max;
            var funcType = '[object Function]';

            var concatty = function concatty(a, b) {
                var arr = [];

                for (var i = 0; i < a.length; i += 1) {
                    arr[i] = a[i];
                }
                for (var j = 0; j < b.length; j += 1) {
                    arr[j + a.length] = b[j];
                }

                return arr;
            };

            var slicy = function slicy(arrLike, offset) {
                var arr = [];
                for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
                    arr[j] = arrLike[i];
                }
                return arr;
            };

            var joiny = function joiny(arr, joiner) {
                var str = '';
                for (var i = 0; i < arr.length; i += 1) {
                    str += arr[i];
                    if (i + 1 < arr.length) {
                        str += joiner;
                    }
                }
                return str;
            };

            module.exports = function bind(that) {
                var target = this;
                if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
                    throw new TypeError(ERROR_MESSAGE + target);
                }
                var args = slicy(arguments, 1);

                var bound;
                var binder = function binder() {
                    if (this instanceof bound) {
                        var result = target.apply(this, concatty(args, arguments));
                        if (Object(result) === result) {
                            return result;
                        }
                        return this;
                    }
                    return target.apply(that, concatty(args, arguments));
                };

                var boundLength = max(0, target.length - args.length);
                var boundArgs = [];
                for (var i = 0; i < boundLength; i++) {
                    boundArgs[i] = '$' + i;
                }

                bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

                if (target.prototype) {
                    var Empty = function Empty() {};
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    Empty.prototype = null;
                }

                return bound;
            };
        }, {}], 14: [function (require, module, exports) {
            'use strict';

            var implementation = require('./implementation');

            module.exports = Function.prototype.bind || implementation;
        }, { "./implementation": 13 }], 15: [function (require, module, exports) {
            'use strict';

            var undefined;

            var $Error = require('es-errors');
            var $EvalError = require('es-errors/eval');
            var $RangeError = require('es-errors/range');
            var $ReferenceError = require('es-errors/ref');
            var $SyntaxError = require('es-errors/syntax');
            var $TypeError = require('es-errors/type');
            var $URIError = require('es-errors/uri');

            var $Function = Function;

            // eslint-disable-next-line consistent-return
            var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
                try {
                    return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
                } catch (e) {}
            };

            var $gOPD = Object.getOwnPropertyDescriptor;
            if ($gOPD) {
                try {
                    $gOPD({}, '');
                } catch (e) {
                    $gOPD = null; // this is IE 8, which has a broken gOPD
                }
            }

            var throwTypeError = function throwTypeError() {
                throw new $TypeError();
            };
            var ThrowTypeError = $gOPD ? function () {
                try {
                    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
                    arguments.callee; // IE 8 does not throw here
                    return throwTypeError;
                } catch (calleeThrows) {
                    try {
                        // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
                        return $gOPD(arguments, 'callee').get;
                    } catch (gOPDthrows) {
                        return throwTypeError;
                    }
                }
            }() : throwTypeError;

            var hasSymbols = require('has-symbols')();
            var hasProto = require('has-proto')();

            var getProto = Object.getPrototypeOf || (hasProto ? function (x) {
                return x.__proto__;
            } // eslint-disable-line no-proto
            : null);

            var needsEval = {};

            var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

            var INTRINSICS = {
                __proto__: null,
                '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
                '%Array%': Array,
                '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
                '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
                '%AsyncFromSyncIteratorPrototype%': undefined,
                '%AsyncFunction%': needsEval,
                '%AsyncGenerator%': needsEval,
                '%AsyncGeneratorFunction%': needsEval,
                '%AsyncIteratorPrototype%': needsEval,
                '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
                '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
                '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
                '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
                '%Boolean%': Boolean,
                '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
                '%Date%': Date,
                '%decodeURI%': decodeURI,
                '%decodeURIComponent%': decodeURIComponent,
                '%encodeURI%': encodeURI,
                '%encodeURIComponent%': encodeURIComponent,
                '%Error%': $Error,
                '%eval%': eval, // eslint-disable-line no-eval
                '%EvalError%': $EvalError,
                '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
                '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
                '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
                '%Function%': $Function,
                '%GeneratorFunction%': needsEval,
                '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
                '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
                '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
                '%isFinite%': isFinite,
                '%isNaN%': isNaN,
                '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
                '%JSON%': (typeof JSON === "undefined" ? "undefined" : _typeof(JSON)) === 'object' ? JSON : undefined,
                '%Map%': typeof Map === 'undefined' ? undefined : Map,
                '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
                '%Math%': Math,
                '%Number%': Number,
                '%Object%': Object,
                '%parseFloat%': parseFloat,
                '%parseInt%': parseInt,
                '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
                '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
                '%RangeError%': $RangeError,
                '%ReferenceError%': $ReferenceError,
                '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
                '%RegExp%': RegExp,
                '%Set%': typeof Set === 'undefined' ? undefined : Set,
                '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
                '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
                '%String%': String,
                '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
                '%Symbol%': hasSymbols ? Symbol : undefined,
                '%SyntaxError%': $SyntaxError,
                '%ThrowTypeError%': ThrowTypeError,
                '%TypedArray%': TypedArray,
                '%TypeError%': $TypeError,
                '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
                '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
                '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
                '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
                '%URIError%': $URIError,
                '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
                '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
                '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
            };

            if (getProto) {
                try {
                    null.error; // eslint-disable-line no-unused-expressions
                } catch (e) {
                    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
                    var errorProto = getProto(getProto(e));
                    INTRINSICS['%Error.prototype%'] = errorProto;
                }
            }

            var doEval = function doEval(name) {
                var value;
                if (name === '%AsyncFunction%') {
                    value = getEvalledConstructor('async function () {}');
                } else if (name === '%GeneratorFunction%') {
                    value = getEvalledConstructor('function* () {}');
                } else if (name === '%AsyncGeneratorFunction%') {
                    value = getEvalledConstructor('async function* () {}');
                } else if (name === '%AsyncGenerator%') {
                    var fn = doEval('%AsyncGeneratorFunction%');
                    if (fn) {
                        value = fn.prototype;
                    }
                } else if (name === '%AsyncIteratorPrototype%') {
                    var gen = doEval('%AsyncGenerator%');
                    if (gen && getProto) {
                        value = getProto(gen.prototype);
                    }
                }

                INTRINSICS[name] = value;

                return value;
            };

            var LEGACY_ALIASES = {
                __proto__: null,
                '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
                '%ArrayPrototype%': ['Array', 'prototype'],
                '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
                '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
                '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
                '%ArrayProto_values%': ['Array', 'prototype', 'values'],
                '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
                '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
                '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
                '%BooleanPrototype%': ['Boolean', 'prototype'],
                '%DataViewPrototype%': ['DataView', 'prototype'],
                '%DatePrototype%': ['Date', 'prototype'],
                '%ErrorPrototype%': ['Error', 'prototype'],
                '%EvalErrorPrototype%': ['EvalError', 'prototype'],
                '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
                '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
                '%FunctionPrototype%': ['Function', 'prototype'],
                '%Generator%': ['GeneratorFunction', 'prototype'],
                '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
                '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
                '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
                '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
                '%JSONParse%': ['JSON', 'parse'],
                '%JSONStringify%': ['JSON', 'stringify'],
                '%MapPrototype%': ['Map', 'prototype'],
                '%NumberPrototype%': ['Number', 'prototype'],
                '%ObjectPrototype%': ['Object', 'prototype'],
                '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
                '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
                '%PromisePrototype%': ['Promise', 'prototype'],
                '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
                '%Promise_all%': ['Promise', 'all'],
                '%Promise_reject%': ['Promise', 'reject'],
                '%Promise_resolve%': ['Promise', 'resolve'],
                '%RangeErrorPrototype%': ['RangeError', 'prototype'],
                '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
                '%RegExpPrototype%': ['RegExp', 'prototype'],
                '%SetPrototype%': ['Set', 'prototype'],
                '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
                '%StringPrototype%': ['String', 'prototype'],
                '%SymbolPrototype%': ['Symbol', 'prototype'],
                '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
                '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
                '%TypeErrorPrototype%': ['TypeError', 'prototype'],
                '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
                '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
                '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
                '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
                '%URIErrorPrototype%': ['URIError', 'prototype'],
                '%WeakMapPrototype%': ['WeakMap', 'prototype'],
                '%WeakSetPrototype%': ['WeakSet', 'prototype']
            };

            var bind = require('function-bind');
            var hasOwn = require('hasown');
            var $concat = bind.call(Function.call, Array.prototype.concat);
            var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
            var $replace = bind.call(Function.call, String.prototype.replace);
            var $strSlice = bind.call(Function.call, String.prototype.slice);
            var $exec = bind.call(Function.call, RegExp.prototype.exec);

            /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
            var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
            var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
            var stringToPath = function stringToPath(string) {
                var first = $strSlice(string, 0, 1);
                var last = $strSlice(string, -1);
                if (first === '%' && last !== '%') {
                    throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
                } else if (last === '%' && first !== '%') {
                    throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
                }
                var result = [];
                $replace(string, rePropName, function (match, number, quote, subString) {
                    result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
                });
                return result;
            };
            /* end adaptation */

            var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
                var intrinsicName = name;
                var alias;
                if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
                    alias = LEGACY_ALIASES[intrinsicName];
                    intrinsicName = '%' + alias[0] + '%';
                }

                if (hasOwn(INTRINSICS, intrinsicName)) {
                    var value = INTRINSICS[intrinsicName];
                    if (value === needsEval) {
                        value = doEval(intrinsicName);
                    }
                    if (typeof value === 'undefined' && !allowMissing) {
                        throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
                    }

                    return {
                        alias: alias,
                        name: intrinsicName,
                        value: value
                    };
                }

                throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
            };

            module.exports = function GetIntrinsic(name, allowMissing) {
                if (typeof name !== 'string' || name.length === 0) {
                    throw new $TypeError('intrinsic name must be a non-empty string');
                }
                if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
                    throw new $TypeError('"allowMissing" argument must be a boolean');
                }

                if ($exec(/^%?[^%]*%?$/, name) === null) {
                    throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
                }
                var parts = stringToPath(name);
                var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

                var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
                var intrinsicRealName = intrinsic.name;
                var value = intrinsic.value;
                var skipFurtherCaching = false;

                var alias = intrinsic.alias;
                if (alias) {
                    intrinsicBaseName = alias[0];
                    $spliceApply(parts, $concat([0, 1], alias));
                }

                for (var i = 1, isOwn = true; i < parts.length; i += 1) {
                    var part = parts[i];
                    var first = $strSlice(part, 0, 1);
                    var last = $strSlice(part, -1);
                    if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
                        throw new $SyntaxError('property names with quotes must have matching quotes');
                    }
                    if (part === 'constructor' || !isOwn) {
                        skipFurtherCaching = true;
                    }

                    intrinsicBaseName += '.' + part;
                    intrinsicRealName = '%' + intrinsicBaseName + '%';

                    if (hasOwn(INTRINSICS, intrinsicRealName)) {
                        value = INTRINSICS[intrinsicRealName];
                    } else if (value != null) {
                        if (!(part in value)) {
                            if (!allowMissing) {
                                throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                            }
                            return void undefined;
                        }
                        if ($gOPD && i + 1 >= parts.length) {
                            var desc = $gOPD(value, part);
                            isOwn = !!desc;

                            // By convention, when a data property is converted to an accessor
                            // property to emulate a data property that does not suffer from
                            // the override mistake, that accessor's getter is marked with
                            // an `originalValue` property. Here, when we detect this, we
                            // uphold the illusion by pretending to see that original data
                            // property, i.e., returning the value rather than the getter
                            // itself.
                            if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
                                value = desc.get;
                            } else {
                                value = value[part];
                            }
                        } else {
                            isOwn = hasOwn(value, part);
                            value = value[part];
                        }

                        if (isOwn && !skipFurtherCaching) {
                            INTRINSICS[intrinsicRealName] = value;
                        }
                    }
                }
                return value;
            };
        }, { "es-errors": 7, "es-errors/eval": 6, "es-errors/range": 8, "es-errors/ref": 9, "es-errors/syntax": 10, "es-errors/type": 11, "es-errors/uri": 12, "function-bind": 14, "has-proto": 18, "has-symbols": 19, "hasown": 21 }], 16: [function (require, module, exports) {
            'use strict';

            var GetIntrinsic = require('get-intrinsic');

            var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

            if ($gOPD) {
                try {
                    $gOPD([], 'length');
                } catch (e) {
                    // IE 8 has a broken gOPD
                    $gOPD = null;
                }
            }

            module.exports = $gOPD;
        }, { "get-intrinsic": 15 }], 17: [function (require, module, exports) {
            'use strict';

            var $defineProperty = require('es-define-property');

            var hasPropertyDescriptors = function hasPropertyDescriptors() {
                return !!$defineProperty;
            };

            hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
                // node v0.6 has a bug where array lengths can be Set but not Defined
                if (!$defineProperty) {
                    return null;
                }
                try {
                    return $defineProperty([], 'length', { value: 1 }).length !== 1;
                } catch (e) {
                    // In Firefox 4-22, defining length on an array throws an exception.
                    return true;
                }
            };

            module.exports = hasPropertyDescriptors;
        }, { "es-define-property": 5 }], 18: [function (require, module, exports) {
            'use strict';

            var test = {
                __proto__: null,
                foo: {}
            };

            var $Object = Object;

            /** @type {import('.')} */
            module.exports = function hasProto() {
                // @ts-expect-error: TS errors on an inherited property for some reason
                return { __proto__: test }.foo === test.foo && !(test instanceof $Object);
            };
        }, {}], 19: [function (require, module, exports) {
            'use strict';

            var origSymbol = typeof Symbol !== 'undefined' && Symbol;
            var hasSymbolSham = require('./shams');

            module.exports = function hasNativeSymbols() {
                if (typeof origSymbol !== 'function') {
                    return false;
                }
                if (typeof Symbol !== 'function') {
                    return false;
                }
                if (_typeof(origSymbol('foo')) !== 'symbol') {
                    return false;
                }
                if (_typeof(Symbol('bar')) !== 'symbol') {
                    return false;
                }

                return hasSymbolSham();
            };
        }, { "./shams": 20 }], 20: [function (require, module, exports) {
            'use strict';

            /* eslint complexity: [2, 18], max-statements: [2, 33] */

            module.exports = function hasSymbols() {
                if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
                    return false;
                }
                if (_typeof(Symbol.iterator) === 'symbol') {
                    return true;
                }

                var obj = {};
                var sym = Symbol('test');
                var symObj = Object(sym);
                if (typeof sym === 'string') {
                    return false;
                }

                if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
                    return false;
                }
                if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
                    return false;
                }

                // temp disabled per https://github.com/ljharb/object.assign/issues/17
                // if (sym instanceof Symbol) { return false; }
                // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
                // if (!(symObj instanceof Symbol)) { return false; }

                // if (typeof Symbol.prototype.toString !== 'function') { return false; }
                // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

                var symVal = 42;
                obj[sym] = symVal;
                for (sym in obj) {
                    return false;
                } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
                if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
                    return false;
                }

                if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
                    return false;
                }

                var syms = Object.getOwnPropertySymbols(obj);
                if (syms.length !== 1 || syms[0] !== sym) {
                    return false;
                }

                if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
                    return false;
                }

                if (typeof Object.getOwnPropertyDescriptor === 'function') {
                    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
                    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
                        return false;
                    }
                }

                return true;
            };
        }, {}], 21: [function (require, module, exports) {
            'use strict';

            var call = Function.prototype.call;
            var $hasOwn = Object.prototype.hasOwnProperty;
            var bind = require('function-bind');

            /** @type {import('.')} */
            module.exports = bind.call(call, $hasOwn);
        }, { "function-bind": 14 }], 22: [function (require, module, exports) {
            (function (global) {
                (function () {
                    var hasMap = typeof Map === 'function' && Map.prototype;
                    var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
                    var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
                    var mapForEach = hasMap && Map.prototype.forEach;
                    var hasSet = typeof Set === 'function' && Set.prototype;
                    var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
                    var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
                    var setForEach = hasSet && Set.prototype.forEach;
                    var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
                    var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
                    var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
                    var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
                    var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
                    var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
                    var booleanValueOf = Boolean.prototype.valueOf;
                    var objectToString = Object.prototype.toString;
                    var functionToString = Function.prototype.toString;
                    var $match = String.prototype.match;
                    var $slice = String.prototype.slice;
                    var $replace = String.prototype.replace;
                    var $toUpperCase = String.prototype.toUpperCase;
                    var $toLowerCase = String.prototype.toLowerCase;
                    var $test = RegExp.prototype.test;
                    var $concat = Array.prototype.concat;
                    var $join = Array.prototype.join;
                    var $arrSlice = Array.prototype.slice;
                    var $floor = Math.floor;
                    var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
                    var gOPS = Object.getOwnPropertySymbols;
                    var symToString = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol' ? Symbol.prototype.toString : null;
                    var hasShammedSymbols = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'object';
                    // ie, `has-tostringtag/shams
                    var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (_typeof(Symbol.toStringTag) === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
                    var isEnumerable = Object.prototype.propertyIsEnumerable;

                    var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
                    ? function (O) {
                        return O.__proto__; // eslint-disable-line no-proto
                    } : null);

                    function addNumericSeparator(num, str) {
                        if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) {
                            return str;
                        }
                        var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
                        if (typeof num === 'number') {
                            var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
                            if (int !== num) {
                                var intStr = String(int);
                                var dec = $slice.call(str, intStr.length + 1);
                                return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
                            }
                        }
                        return $replace.call(str, sepRegex, '$&_');
                    }

                    var utilInspect = require('./util.inspect');
                    var inspectCustom = utilInspect.custom;
                    var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

                    module.exports = function inspect_(obj, options, depth, seen) {
                        var opts = options || {};

                        if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
                            throw new TypeError('option "quoteStyle" must be "single" or "double"');
                        }
                        if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
                            throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
                        }
                        var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
                        if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
                            throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
                        }

                        if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
                            throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
                        }
                        if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
                            throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
                        }
                        var numericSeparator = opts.numericSeparator;

                        if (typeof obj === 'undefined') {
                            return 'undefined';
                        }
                        if (obj === null) {
                            return 'null';
                        }
                        if (typeof obj === 'boolean') {
                            return obj ? 'true' : 'false';
                        }

                        if (typeof obj === 'string') {
                            return inspectString(obj, opts);
                        }
                        if (typeof obj === 'number') {
                            if (obj === 0) {
                                return Infinity / obj > 0 ? '0' : '-0';
                            }
                            var str = String(obj);
                            return numericSeparator ? addNumericSeparator(obj, str) : str;
                        }
                        if (typeof obj === 'bigint') {
                            var bigIntStr = String(obj) + 'n';
                            return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
                        }

                        var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
                        if (typeof depth === 'undefined') {
                            depth = 0;
                        }
                        if (depth >= maxDepth && maxDepth > 0 && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object') {
                            return isArray(obj) ? '[Array]' : '[Object]';
                        }

                        var indent = getIndent(opts, depth);

                        if (typeof seen === 'undefined') {
                            seen = [];
                        } else if (indexOf(seen, obj) >= 0) {
                            return '[Circular]';
                        }

                        function inspect(value, from, noIndent) {
                            if (from) {
                                seen = $arrSlice.call(seen);
                                seen.push(from);
                            }
                            if (noIndent) {
                                var newOpts = {
                                    depth: opts.depth
                                };
                                if (has(opts, 'quoteStyle')) {
                                    newOpts.quoteStyle = opts.quoteStyle;
                                }
                                return inspect_(value, newOpts, depth + 1, seen);
                            }
                            return inspect_(value, opts, depth + 1, seen);
                        }

                        if (typeof obj === 'function' && !isRegExp(obj)) {
                            // in older engines, regexes are callable
                            var name = nameOf(obj);
                            var keys = arrObjKeys(obj, inspect);
                            return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
                        }
                        if (isSymbol(obj)) {
                            var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
                            return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
                        }
                        if (isElement(obj)) {
                            var s = '<' + $toLowerCase.call(String(obj.nodeName));
                            var attrs = obj.attributes || [];
                            for (var i = 0; i < attrs.length; i++) {
                                s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
                            }
                            s += '>';
                            if (obj.childNodes && obj.childNodes.length) {
                                s += '...';
                            }
                            s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
                            return s;
                        }
                        if (isArray(obj)) {
                            if (obj.length === 0) {
                                return '[]';
                            }
                            var xs = arrObjKeys(obj, inspect);
                            if (indent && !singleLineValues(xs)) {
                                return '[' + indentedJoin(xs, indent) + ']';
                            }
                            return '[ ' + $join.call(xs, ', ') + ' ]';
                        }
                        if (isError(obj)) {
                            var parts = arrObjKeys(obj, inspect);
                            if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
                                return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
                            }
                            if (parts.length === 0) {
                                return '[' + String(obj) + ']';
                            }
                            return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
                        }
                        if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && customInspect) {
                            if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
                                return utilInspect(obj, { depth: maxDepth - depth });
                            } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
                                return obj.inspect();
                            }
                        }
                        if (isMap(obj)) {
                            var mapParts = [];
                            if (mapForEach) {
                                mapForEach.call(obj, function (value, key) {
                                    mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
                                });
                            }
                            return collectionOf('Map', mapSize.call(obj), mapParts, indent);
                        }
                        if (isSet(obj)) {
                            var setParts = [];
                            if (setForEach) {
                                setForEach.call(obj, function (value) {
                                    setParts.push(inspect(value, obj));
                                });
                            }
                            return collectionOf('Set', setSize.call(obj), setParts, indent);
                        }
                        if (isWeakMap(obj)) {
                            return weakCollectionOf('WeakMap');
                        }
                        if (isWeakSet(obj)) {
                            return weakCollectionOf('WeakSet');
                        }
                        if (isWeakRef(obj)) {
                            return weakCollectionOf('WeakRef');
                        }
                        if (isNumber(obj)) {
                            return markBoxed(inspect(Number(obj)));
                        }
                        if (isBigInt(obj)) {
                            return markBoxed(inspect(bigIntValueOf.call(obj)));
                        }
                        if (isBoolean(obj)) {
                            return markBoxed(booleanValueOf.call(obj));
                        }
                        if (isString(obj)) {
                            return markBoxed(inspect(String(obj)));
                        }
                        // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
                        /* eslint-env browser */
                        if (typeof window !== 'undefined' && obj === window) {
                            return '{ [object Window] }';
                        }
                        if (typeof globalThis !== 'undefined' && obj === globalThis || typeof global !== 'undefined' && obj === global) {
                            return '{ [object globalThis] }';
                        }
                        if (!isDate(obj) && !isRegExp(obj)) {
                            var ys = arrObjKeys(obj, inspect);
                            var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
                            var protoTag = obj instanceof Object ? '' : 'null prototype';
                            var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
                            var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
                            var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
                            if (ys.length === 0) {
                                return tag + '{}';
                            }
                            if (indent) {
                                return tag + '{' + indentedJoin(ys, indent) + '}';
                            }
                            return tag + '{ ' + $join.call(ys, ', ') + ' }';
                        }
                        return String(obj);
                    };

                    function wrapQuotes(s, defaultStyle, opts) {
                        var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
                        return quoteChar + s + quoteChar;
                    }

                    function quote(s) {
                        return $replace.call(String(s), /"/g, '&quot;');
                    }

                    function isArray(obj) {
                        return toStr(obj) === '[object Array]' && (!toStringTag || !((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && toStringTag in obj));
                    }
                    function isDate(obj) {
                        return toStr(obj) === '[object Date]' && (!toStringTag || !((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && toStringTag in obj));
                    }
                    function isRegExp(obj) {
                        return toStr(obj) === '[object RegExp]' && (!toStringTag || !((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && toStringTag in obj));
                    }
                    function isError(obj) {
                        return toStr(obj) === '[object Error]' && (!toStringTag || !((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && toStringTag in obj));
                    }
                    function isString(obj) {
                        return toStr(obj) === '[object String]' && (!toStringTag || !((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && toStringTag in obj));
                    }
                    function isNumber(obj) {
                        return toStr(obj) === '[object Number]' && (!toStringTag || !((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && toStringTag in obj));
                    }
                    function isBoolean(obj) {
                        return toStr(obj) === '[object Boolean]' && (!toStringTag || !((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && toStringTag in obj));
                    }

                    // Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
                    function isSymbol(obj) {
                        if (hasShammedSymbols) {
                            return obj && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' && obj instanceof Symbol;
                        }
                        if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'symbol') {
                            return true;
                        }
                        if (!obj || (typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== 'object' || !symToString) {
                            return false;
                        }
                        try {
                            symToString.call(obj);
                            return true;
                        } catch (e) {}
                        return false;
                    }

                    function isBigInt(obj) {
                        if (!obj || (typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== 'object' || !bigIntValueOf) {
                            return false;
                        }
                        try {
                            bigIntValueOf.call(obj);
                            return true;
                        } catch (e) {}
                        return false;
                    }

                    var hasOwn = Object.prototype.hasOwnProperty || function (key) {
                        return key in this;
                    };
                    function has(obj, key) {
                        return hasOwn.call(obj, key);
                    }

                    function toStr(obj) {
                        return objectToString.call(obj);
                    }

                    function nameOf(f) {
                        if (f.name) {
                            return f.name;
                        }
                        var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
                        if (m) {
                            return m[1];
                        }
                        return null;
                    }

                    function indexOf(xs, x) {
                        if (xs.indexOf) {
                            return xs.indexOf(x);
                        }
                        for (var i = 0, l = xs.length; i < l; i++) {
                            if (xs[i] === x) {
                                return i;
                            }
                        }
                        return -1;
                    }

                    function isMap(x) {
                        if (!mapSize || !x || (typeof x === "undefined" ? "undefined" : _typeof(x)) !== 'object') {
                            return false;
                        }
                        try {
                            mapSize.call(x);
                            try {
                                setSize.call(x);
                            } catch (s) {
                                return true;
                            }
                            return x instanceof Map; // core-js workaround, pre-v2.5.0
                        } catch (e) {}
                        return false;
                    }

                    function isWeakMap(x) {
                        if (!weakMapHas || !x || (typeof x === "undefined" ? "undefined" : _typeof(x)) !== 'object') {
                            return false;
                        }
                        try {
                            weakMapHas.call(x, weakMapHas);
                            try {
                                weakSetHas.call(x, weakSetHas);
                            } catch (s) {
                                return true;
                            }
                            return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
                        } catch (e) {}
                        return false;
                    }

                    function isWeakRef(x) {
                        if (!weakRefDeref || !x || (typeof x === "undefined" ? "undefined" : _typeof(x)) !== 'object') {
                            return false;
                        }
                        try {
                            weakRefDeref.call(x);
                            return true;
                        } catch (e) {}
                        return false;
                    }

                    function isSet(x) {
                        if (!setSize || !x || (typeof x === "undefined" ? "undefined" : _typeof(x)) !== 'object') {
                            return false;
                        }
                        try {
                            setSize.call(x);
                            try {
                                mapSize.call(x);
                            } catch (m) {
                                return true;
                            }
                            return x instanceof Set; // core-js workaround, pre-v2.5.0
                        } catch (e) {}
                        return false;
                    }

                    function isWeakSet(x) {
                        if (!weakSetHas || !x || (typeof x === "undefined" ? "undefined" : _typeof(x)) !== 'object') {
                            return false;
                        }
                        try {
                            weakSetHas.call(x, weakSetHas);
                            try {
                                weakMapHas.call(x, weakMapHas);
                            } catch (s) {
                                return true;
                            }
                            return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
                        } catch (e) {}
                        return false;
                    }

                    function isElement(x) {
                        if (!x || (typeof x === "undefined" ? "undefined" : _typeof(x)) !== 'object') {
                            return false;
                        }
                        if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
                            return true;
                        }
                        return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
                    }

                    function inspectString(str, opts) {
                        if (str.length > opts.maxStringLength) {
                            var remaining = str.length - opts.maxStringLength;
                            var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
                            return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
                        }
                        // eslint-disable-next-line no-control-regex
                        var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
                        return wrapQuotes(s, 'single', opts);
                    }

                    function lowbyte(c) {
                        var n = c.charCodeAt(0);
                        var x = {
                            8: 'b',
                            9: 't',
                            10: 'n',
                            12: 'f',
                            13: 'r'
                        }[n];
                        if (x) {
                            return '\\' + x;
                        }
                        return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
                    }

                    function markBoxed(str) {
                        return 'Object(' + str + ')';
                    }

                    function weakCollectionOf(type) {
                        return type + ' { ? }';
                    }

                    function collectionOf(type, size, entries, indent) {
                        var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
                        return type + ' (' + size + ') {' + joinedEntries + '}';
                    }

                    function singleLineValues(xs) {
                        for (var i = 0; i < xs.length; i++) {
                            if (indexOf(xs[i], '\n') >= 0) {
                                return false;
                            }
                        }
                        return true;
                    }

                    function getIndent(opts, depth) {
                        var baseIndent;
                        if (opts.indent === '\t') {
                            baseIndent = '\t';
                        } else if (typeof opts.indent === 'number' && opts.indent > 0) {
                            baseIndent = $join.call(Array(opts.indent + 1), ' ');
                        } else {
                            return null;
                        }
                        return {
                            base: baseIndent,
                            prev: $join.call(Array(depth + 1), baseIndent)
                        };
                    }

                    function indentedJoin(xs, indent) {
                        if (xs.length === 0) {
                            return '';
                        }
                        var lineJoiner = '\n' + indent.prev + indent.base;
                        return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
                    }

                    function arrObjKeys(obj, inspect) {
                        var isArr = isArray(obj);
                        var xs = [];
                        if (isArr) {
                            xs.length = obj.length;
                            for (var i = 0; i < obj.length; i++) {
                                xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
                            }
                        }
                        var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
                        var symMap;
                        if (hasShammedSymbols) {
                            symMap = {};
                            for (var k = 0; k < syms.length; k++) {
                                symMap['$' + syms[k]] = syms[k];
                            }
                        }

                        for (var key in obj) {
                            // eslint-disable-line no-restricted-syntax
                            if (!has(obj, key)) {
                                continue;
                            } // eslint-disable-line no-restricted-syntax, no-continue
                            if (isArr && String(Number(key)) === key && key < obj.length) {
                                continue;
                            } // eslint-disable-line no-restricted-syntax, no-continue
                            if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
                                // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
                                continue; // eslint-disable-line no-restricted-syntax, no-continue
                            } else if ($test.call(/[^\w$]/, key)) {
                                xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
                            } else {
                                xs.push(key + ': ' + inspect(obj[key], obj));
                            }
                        }
                        if (typeof gOPS === 'function') {
                            for (var j = 0; j < syms.length; j++) {
                                if (isEnumerable.call(obj, syms[j])) {
                                    xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
                                }
                            }
                        }
                        return xs;
                    }
                }).call(this);
            }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        }, { "./util.inspect": 1 }], 23: [function (require, module, exports) {
            (function (global) {
                (function () {
                    /*! https://mths.be/punycode v1.4.1 by @mathias */
                    ;(function (root) {

                        /** Detect free variables */
                        var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
                        var freeModule = (typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module && !module.nodeType && module;
                        var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global;
                        if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
                            root = freeGlobal;
                        }

                        /**
                         * The `punycode` object.
                         * @name punycode
                         * @type Object
                         */
                        var punycode,


                        /** Highest positive signed 32-bit float value */
                        maxInt = 2147483647,
                            // aka. 0x7FFFFFFF or 2^31-1

                        /** Bootstring parameters */
                        base = 36,
                            tMin = 1,
                            tMax = 26,
                            skew = 38,
                            damp = 700,
                            initialBias = 72,
                            initialN = 128,
                            // 0x80
                        delimiter = '-',
                            // '\x2D'

                        /** Regular expressions */
                        regexPunycode = /^xn--/,
                            regexNonASCII = /[^\x20-\x7E]/,
                            // unprintable ASCII chars + non-ASCII chars
                        regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
                            // RFC 3490 separators

                        /** Error messages */
                        errors = {
                            'overflow': 'Overflow: input needs wider integers to process',
                            'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
                            'invalid-input': 'Invalid input'
                        },


                        /** Convenience shortcuts */
                        baseMinusTMin = base - tMin,
                            floor = Math.floor,
                            stringFromCharCode = String.fromCharCode,


                        /** Temporary variable */
                        key;

                        /*--------------------------------------------------------------------------*/

                        /**
                         * A generic error utility function.
                         * @private
                         * @param {String} type The error type.
                         * @returns {Error} Throws a `RangeError` with the applicable error message.
                         */
                        function error(type) {
                            throw new RangeError(errors[type]);
                        }

                        /**
                         * A generic `Array#map` utility function.
                         * @private
                         * @param {Array} array The array to iterate over.
                         * @param {Function} callback The function that gets called for every array
                         * item.
                         * @returns {Array} A new array of values returned by the callback function.
                         */
                        function map(array, fn) {
                            var length = array.length;
                            var result = [];
                            while (length--) {
                                result[length] = fn(array[length]);
                            }
                            return result;
                        }

                        /**
                         * A simple `Array#map`-like wrapper to work with domain name strings or email
                         * addresses.
                         * @private
                         * @param {String} domain The domain name or email address.
                         * @param {Function} callback The function that gets called for every
                         * character.
                         * @returns {Array} A new string of characters returned by the callback
                         * function.
                         */
                        function mapDomain(string, fn) {
                            var parts = string.split('@');
                            var result = '';
                            if (parts.length > 1) {
                                // In email addresses, only the domain name should be punycoded. Leave
                                // the local part (i.e. everything up to `@`) intact.
                                result = parts[0] + '@';
                                string = parts[1];
                            }
                            // Avoid `split(regex)` for IE8 compatibility. See #17.
                            string = string.replace(regexSeparators, '\x2E');
                            var labels = string.split('.');
                            var encoded = map(labels, fn).join('.');
                            return result + encoded;
                        }

                        /**
                         * Creates an array containing the numeric code points of each Unicode
                         * character in the string. While JavaScript uses UCS-2 internally,
                         * this function will convert a pair of surrogate halves (each of which
                         * UCS-2 exposes as separate characters) into a single code point,
                         * matching UTF-16.
                         * @see `punycode.ucs2.encode`
                         * @see <https://mathiasbynens.be/notes/javascript-encoding>
                         * @memberOf punycode.ucs2
                         * @name decode
                         * @param {String} string The Unicode input string (UCS-2).
                         * @returns {Array} The new array of code points.
                         */
                        function ucs2decode(string) {
                            var output = [],
                                counter = 0,
                                length = string.length,
                                value,
                                extra;
                            while (counter < length) {
                                value = string.charCodeAt(counter++);
                                if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                                    // high surrogate, and there is a next character
                                    extra = string.charCodeAt(counter++);
                                    if ((extra & 0xFC00) == 0xDC00) {
                                        // low surrogate
                                        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                                    } else {
                                        // unmatched surrogate; only append this code unit, in case the next
                                        // code unit is the high surrogate of a surrogate pair
                                        output.push(value);
                                        counter--;
                                    }
                                } else {
                                    output.push(value);
                                }
                            }
                            return output;
                        }

                        /**
                         * Creates a string based on an array of numeric code points.
                         * @see `punycode.ucs2.decode`
                         * @memberOf punycode.ucs2
                         * @name encode
                         * @param {Array} codePoints The array of numeric code points.
                         * @returns {String} The new Unicode string (UCS-2).
                         */
                        function ucs2encode(array) {
                            return map(array, function (value) {
                                var output = '';
                                if (value > 0xFFFF) {
                                    value -= 0x10000;
                                    output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                                    value = 0xDC00 | value & 0x3FF;
                                }
                                output += stringFromCharCode(value);
                                return output;
                            }).join('');
                        }

                        /**
                         * Converts a basic code point into a digit/integer.
                         * @see `digitToBasic()`
                         * @private
                         * @param {Number} codePoint The basic numeric code point value.
                         * @returns {Number} The numeric value of a basic code point (for use in
                         * representing integers) in the range `0` to `base - 1`, or `base` if
                         * the code point does not represent a value.
                         */
                        function basicToDigit(codePoint) {
                            if (codePoint - 48 < 10) {
                                return codePoint - 22;
                            }
                            if (codePoint - 65 < 26) {
                                return codePoint - 65;
                            }
                            if (codePoint - 97 < 26) {
                                return codePoint - 97;
                            }
                            return base;
                        }

                        /**
                         * Converts a digit/integer into a basic code point.
                         * @see `basicToDigit()`
                         * @private
                         * @param {Number} digit The numeric value of a basic code point.
                         * @returns {Number} The basic code point whose value (when used for
                         * representing integers) is `digit`, which needs to be in the range
                         * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
                         * used; else, the lowercase form is used. The behavior is undefined
                         * if `flag` is non-zero and `digit` has no uppercase form.
                         */
                        function digitToBasic(digit, flag) {
                            //  0..25 map to ASCII a..z or A..Z
                            // 26..35 map to ASCII 0..9
                            return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
                        }

                        /**
                         * Bias adaptation function as per section 3.4 of RFC 3492.
                         * https://tools.ietf.org/html/rfc3492#section-3.4
                         * @private
                         */
                        function adapt(delta, numPoints, firstTime) {
                            var k = 0;
                            delta = firstTime ? floor(delta / damp) : delta >> 1;
                            delta += floor(delta / numPoints);
                            for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
                                delta = floor(delta / baseMinusTMin);
                            }
                            return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
                        }

                        /**
                         * Converts a Punycode string of ASCII-only symbols to a string of Unicode
                         * symbols.
                         * @memberOf punycode
                         * @param {String} input The Punycode string of ASCII-only symbols.
                         * @returns {String} The resulting string of Unicode symbols.
                         */
                        function decode(input) {
                            // Don't use UCS-2
                            var output = [],
                                inputLength = input.length,
                                out,
                                i = 0,
                                n = initialN,
                                bias = initialBias,
                                basic,
                                j,
                                index,
                                oldi,
                                w,
                                k,
                                digit,
                                t,

                            /** Cached calculation results */
                            baseMinusT;

                            // Handle the basic code points: let `basic` be the number of input code
                            // points before the last delimiter, or `0` if there is none, then copy
                            // the first basic code points to the output.

                            basic = input.lastIndexOf(delimiter);
                            if (basic < 0) {
                                basic = 0;
                            }

                            for (j = 0; j < basic; ++j) {
                                // if it's not a basic code point
                                if (input.charCodeAt(j) >= 0x80) {
                                    error('not-basic');
                                }
                                output.push(input.charCodeAt(j));
                            }

                            // Main decoding loop: start just after the last delimiter if any basic code
                            // points were copied; start at the beginning otherwise.

                            for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

                                // `index` is the index of the next character to be consumed.
                                // Decode a generalized variable-length integer into `delta`,
                                // which gets added to `i`. The overflow checking is easier
                                // if we increase `i` as we go, then subtract off its starting
                                // value at the end to obtain `delta`.
                                for (oldi = i, w = 1, k = base;; /* no condition */k += base) {

                                    if (index >= inputLength) {
                                        error('invalid-input');
                                    }

                                    digit = basicToDigit(input.charCodeAt(index++));

                                    if (digit >= base || digit > floor((maxInt - i) / w)) {
                                        error('overflow');
                                    }

                                    i += digit * w;
                                    t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

                                    if (digit < t) {
                                        break;
                                    }

                                    baseMinusT = base - t;
                                    if (w > floor(maxInt / baseMinusT)) {
                                        error('overflow');
                                    }

                                    w *= baseMinusT;
                                }

                                out = output.length + 1;
                                bias = adapt(i - oldi, out, oldi == 0);

                                // `i` was supposed to wrap around from `out` to `0`,
                                // incrementing `n` each time, so we'll fix that now:
                                if (floor(i / out) > maxInt - n) {
                                    error('overflow');
                                }

                                n += floor(i / out);
                                i %= out;

                                // Insert `n` at position `i` of the output
                                output.splice(i++, 0, n);
                            }

                            return ucs2encode(output);
                        }

                        /**
                         * Converts a string of Unicode symbols (e.g. a domain name label) to a
                         * Punycode string of ASCII-only symbols.
                         * @memberOf punycode
                         * @param {String} input The string of Unicode symbols.
                         * @returns {String} The resulting Punycode string of ASCII-only symbols.
                         */
                        function encode(input) {
                            var n,
                                delta,
                                handledCPCount,
                                basicLength,
                                bias,
                                j,
                                m,
                                q,
                                k,
                                t,
                                currentValue,
                                output = [],

                            /** `inputLength` will hold the number of code points in `input`. */
                            inputLength,

                            /** Cached calculation results */
                            handledCPCountPlusOne,
                                baseMinusT,
                                qMinusT;

                            // Convert the input in UCS-2 to Unicode
                            input = ucs2decode(input);

                            // Cache the length
                            inputLength = input.length;

                            // Initialize the state
                            n = initialN;
                            delta = 0;
                            bias = initialBias;

                            // Handle the basic code points
                            for (j = 0; j < inputLength; ++j) {
                                currentValue = input[j];
                                if (currentValue < 0x80) {
                                    output.push(stringFromCharCode(currentValue));
                                }
                            }

                            handledCPCount = basicLength = output.length;

                            // `handledCPCount` is the number of code points that have been handled;
                            // `basicLength` is the number of basic code points.

                            // Finish the basic string - if it is not empty - with a delimiter
                            if (basicLength) {
                                output.push(delimiter);
                            }

                            // Main encoding loop:
                            while (handledCPCount < inputLength) {

                                // All non-basic code points < n have been handled already. Find the next
                                // larger one:
                                for (m = maxInt, j = 0; j < inputLength; ++j) {
                                    currentValue = input[j];
                                    if (currentValue >= n && currentValue < m) {
                                        m = currentValue;
                                    }
                                }

                                // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
                                // but guard against overflow
                                handledCPCountPlusOne = handledCPCount + 1;
                                if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
                                    error('overflow');
                                }

                                delta += (m - n) * handledCPCountPlusOne;
                                n = m;

                                for (j = 0; j < inputLength; ++j) {
                                    currentValue = input[j];

                                    if (currentValue < n && ++delta > maxInt) {
                                        error('overflow');
                                    }

                                    if (currentValue == n) {
                                        // Represent delta as a generalized variable-length integer
                                        for (q = delta, k = base;; /* no condition */k += base) {
                                            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                            if (q < t) {
                                                break;
                                            }
                                            qMinusT = q - t;
                                            baseMinusT = base - t;
                                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                                            q = floor(qMinusT / baseMinusT);
                                        }

                                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                                        delta = 0;
                                        ++handledCPCount;
                                    }
                                }

                                ++delta;
                                ++n;
                            }
                            return output.join('');
                        }

                        /**
                         * Converts a Punycode string representing a domain name or an email address
                         * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
                         * it doesn't matter if you call it on a string that has already been
                         * converted to Unicode.
                         * @memberOf punycode
                         * @param {String} input The Punycoded domain name or email address to
                         * convert to Unicode.
                         * @returns {String} The Unicode representation of the given Punycode
                         * string.
                         */
                        function toUnicode(input) {
                            return mapDomain(input, function (string) {
                                return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
                            });
                        }

                        /**
                         * Converts a Unicode string representing a domain name or an email address to
                         * Punycode. Only the non-ASCII parts of the domain name will be converted,
                         * i.e. it doesn't matter if you call it with a domain that's already in
                         * ASCII.
                         * @memberOf punycode
                         * @param {String} input The domain name or email address to convert, as a
                         * Unicode string.
                         * @returns {String} The Punycode representation of the given domain name or
                         * email address.
                         */
                        function toASCII(input) {
                            return mapDomain(input, function (string) {
                                return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
                            });
                        }

                        /*--------------------------------------------------------------------------*/

                        /** Define the public API */
                        punycode = {
                            /**
                             * A string representing the current Punycode.js version number.
                             * @memberOf punycode
                             * @type String
                             */
                            'version': '1.4.1',
                            /**
                             * An object of methods to convert from JavaScript's internal character
                             * representation (UCS-2) to Unicode code points, and back.
                             * @see <https://mathiasbynens.be/notes/javascript-encoding>
                             * @memberOf punycode
                             * @type Object
                             */
                            'ucs2': {
                                'decode': ucs2decode,
                                'encode': ucs2encode
                            },
                            'decode': decode,
                            'encode': encode,
                            'toASCII': toASCII,
                            'toUnicode': toUnicode
                        };

                        /** Expose `punycode` */
                        // Some AMD build optimizers, like r.js, check for specific condition patterns
                        // like the following:
                        if (typeof define == 'function' && _typeof(define.amd) == 'object' && define.amd) {
                            define('punycode', function () {
                                return punycode;
                            });
                        } else if (freeExports && freeModule) {
                            if (module.exports == freeExports) {
                                // in Node.js, io.js, or RingoJS v0.8.0+
                                freeModule.exports = punycode;
                            } else {
                                // in Narwhal or RingoJS v0.7.0-
                                for (key in punycode) {
                                    punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
                                }
                            }
                        } else {
                            // in Rhino or a web browser
                            root.punycode = punycode;
                        }
                    })(this);
                }).call(this);
            }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        }, {}], 24: [function (require, module, exports) {
            'use strict';

            var replace = String.prototype.replace;
            var percentTwenties = /%20/g;

            var Format = {
                RFC1738: 'RFC1738',
                RFC3986: 'RFC3986'
            };

            module.exports = {
                'default': Format.RFC3986,
                formatters: {
                    RFC1738: function RFC1738(value) {
                        return replace.call(value, percentTwenties, '+');
                    },
                    RFC3986: function RFC3986(value) {
                        return String(value);
                    }
                },
                RFC1738: Format.RFC1738,
                RFC3986: Format.RFC3986
            };
        }, {}], 25: [function (require, module, exports) {
            'use strict';

            var stringify = require('./stringify');
            var parse = require('./parse');
            var formats = require('./formats');

            module.exports = {
                formats: formats,
                parse: parse,
                stringify: stringify
            };
        }, { "./formats": 24, "./parse": 26, "./stringify": 27 }], 26: [function (require, module, exports) {
            'use strict';

            var utils = require('./utils');

            var has = Object.prototype.hasOwnProperty;
            var isArray = Array.isArray;

            var defaults = {
                allowDots: false,
                allowEmptyArrays: false,
                allowPrototypes: false,
                allowSparse: false,
                arrayLimit: 20,
                charset: 'utf-8',
                charsetSentinel: false,
                comma: false,
                decodeDotInKeys: false,
                decoder: utils.decode,
                delimiter: '&',
                depth: 5,
                duplicates: 'combine',
                ignoreQueryPrefix: false,
                interpretNumericEntities: false,
                parameterLimit: 1000,
                parseArrays: true,
                plainObjects: false,
                strictDepth: false,
                strictNullHandling: false
            };

            var interpretNumericEntities = function interpretNumericEntities(str) {
                return str.replace(/&#(\d+);/g, function ($0, numberStr) {
                    return String.fromCharCode(parseInt(numberStr, 10));
                });
            };

            var parseArrayValue = function parseArrayValue(val, options) {
                if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
                    return val.split(',');
                }

                return val;
            };

            // This is what browsers will submit when the ✓ character occurs in an
            // application/x-www-form-urlencoded body and the encoding of the page containing
            // the form is iso-8859-1, or when the submitted form has an accept-charset
            // attribute of iso-8859-1. Presumably also with other charsets that do not contain
            // the ✓ character, such as us-ascii.
            var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

            // These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
            var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

            var parseValues = function parseQueryStringValues(str, options) {
                var obj = { __proto__: null };

                var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
                cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
                var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
                var parts = cleanStr.split(options.delimiter, limit);
                var skipIndex = -1; // Keep track of where the utf8 sentinel was found
                var i;

                var charset = options.charset;
                if (options.charsetSentinel) {
                    for (i = 0; i < parts.length; ++i) {
                        if (parts[i].indexOf('utf8=') === 0) {
                            if (parts[i] === charsetSentinel) {
                                charset = 'utf-8';
                            } else if (parts[i] === isoSentinel) {
                                charset = 'iso-8859-1';
                            }
                            skipIndex = i;
                            i = parts.length; // The eslint settings do not allow break;
                        }
                    }
                }

                for (i = 0; i < parts.length; ++i) {
                    if (i === skipIndex) {
                        continue;
                    }
                    var part = parts[i];

                    var bracketEqualsPos = part.indexOf(']=');
                    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

                    var key, val;
                    if (pos === -1) {
                        key = options.decoder(part, defaults.decoder, charset, 'key');
                        val = options.strictNullHandling ? null : '';
                    } else {
                        key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
                        val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
                            return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                        });
                    }

                    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
                        val = interpretNumericEntities(val);
                    }

                    if (part.indexOf('[]=') > -1) {
                        val = isArray(val) ? [val] : val;
                    }

                    var existing = has.call(obj, key);
                    if (existing && options.duplicates === 'combine') {
                        obj[key] = utils.combine(obj[key], val);
                    } else if (!existing || options.duplicates === 'last') {
                        obj[key] = val;
                    }
                }

                return obj;
            };

            var parseObject = function parseObject(chain, val, options, valuesParsed) {
                var leaf = valuesParsed ? val : parseArrayValue(val, options);

                for (var i = chain.length - 1; i >= 0; --i) {
                    var obj;
                    var root = chain[i];

                    if (root === '[]' && options.parseArrays) {
                        obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
                    } else {
                        obj = options.plainObjects ? Object.create(null) : {};
                        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
                        var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
                        var index = parseInt(decodedRoot, 10);
                        if (!options.parseArrays && decodedRoot === '') {
                            obj = { 0: leaf };
                        } else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                            obj = [];
                            obj[index] = leaf;
                        } else if (decodedRoot !== '__proto__') {
                            obj[decodedRoot] = leaf;
                        }
                    }

                    leaf = obj;
                }

                return leaf;
            };

            var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
                if (!givenKey) {
                    return;
                }

                // Transform dot notation to bracket notation
                var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

                // The regex chunks

                var brackets = /(\[[^[\]]*])/;
                var child = /(\[[^[\]]*])/g;

                // Get the parent

                var segment = options.depth > 0 && brackets.exec(key);
                var parent = segment ? key.slice(0, segment.index) : key;

                // Stash the parent if it exists

                var keys = [];
                if (parent) {
                    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
                    if (!options.plainObjects && has.call(Object.prototype, parent)) {
                        if (!options.allowPrototypes) {
                            return;
                        }
                    }

                    keys.push(parent);
                }

                // Loop through children appending to the array until we hit depth

                var i = 0;
                while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
                    i += 1;
                    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
                        if (!options.allowPrototypes) {
                            return;
                        }
                    }
                    keys.push(segment[1]);
                }

                // If there's a remainder, check strictDepth option for throw, else just add whatever is left

                if (segment) {
                    if (options.strictDepth === true) {
                        throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
                    }
                    keys.push('[' + key.slice(segment.index) + ']');
                }

                return parseObject(keys, val, options, valuesParsed);
            };

            var normalizeParseOptions = function normalizeParseOptions(opts) {
                if (!opts) {
                    return defaults;
                }

                if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
                    throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
                }

                if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
                    throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
                }

                if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
                    throw new TypeError('Decoder has to be a function.');
                }

                if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
                    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
                }
                var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

                var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

                if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
                    throw new TypeError('The duplicates option must be either combine, first, or last');
                }

                var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

                return {
                    allowDots: allowDots,
                    allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
                    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
                    allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
                    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
                    charset: charset,
                    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
                    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
                    decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
                    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
                    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
                    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
                    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
                    duplicates: duplicates,
                    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
                    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
                    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
                    parseArrays: opts.parseArrays !== false,
                    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
                    strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
                    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
                };
            };

            module.exports = function (str, opts) {
                var options = normalizeParseOptions(opts);

                if (str === '' || str === null || typeof str === 'undefined') {
                    return options.plainObjects ? Object.create(null) : {};
                }

                var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
                var obj = options.plainObjects ? Object.create(null) : {};

                // Iterate over the keys and setup the new object

                var keys = Object.keys(tempObj);
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
                    obj = utils.merge(obj, newObj, options);
                }

                if (options.allowSparse === true) {
                    return obj;
                }

                return utils.compact(obj);
            };
        }, { "./utils": 28 }], 27: [function (require, module, exports) {
            'use strict';

            var getSideChannel = require('side-channel');
            var utils = require('./utils');
            var formats = require('./formats');
            var has = Object.prototype.hasOwnProperty;

            var arrayPrefixGenerators = {
                brackets: function brackets(prefix) {
                    return prefix + '[]';
                },
                comma: 'comma',
                indices: function indices(prefix, key) {
                    return prefix + '[' + key + ']';
                },
                repeat: function repeat(prefix) {
                    return prefix;
                }
            };

            var isArray = Array.isArray;
            var push = Array.prototype.push;
            var pushToArray = function pushToArray(arr, valueOrArray) {
                push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
            };

            var toISO = Date.prototype.toISOString;

            var defaultFormat = formats['default'];
            var defaults = {
                addQueryPrefix: false,
                allowDots: false,
                allowEmptyArrays: false,
                arrayFormat: 'indices',
                charset: 'utf-8',
                charsetSentinel: false,
                delimiter: '&',
                encode: true,
                encodeDotInKeys: false,
                encoder: utils.encode,
                encodeValuesOnly: false,
                format: defaultFormat,
                formatter: formats.formatters[defaultFormat],
                // deprecated
                indices: false,
                serializeDate: function serializeDate(date) {
                    return toISO.call(date);
                },
                skipNulls: false,
                strictNullHandling: false
            };

            var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
                return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || (typeof v === "undefined" ? "undefined" : _typeof(v)) === 'symbol' || typeof v === 'bigint';
            };

            var sentinel = {};

            var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
                var obj = object;

                var tmpSc = sideChannel;
                var step = 0;
                var findFlag = false;
                while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
                    // Where object last appeared in the ref tree
                    var pos = tmpSc.get(object);
                    step += 1;
                    if (typeof pos !== 'undefined') {
                        if (pos === step) {
                            throw new RangeError('Cyclic object value');
                        } else {
                            findFlag = true; // Break while
                        }
                    }
                    if (typeof tmpSc.get(sentinel) === 'undefined') {
                        step = 0;
                    }
                }

                if (typeof filter === 'function') {
                    obj = filter(prefix, obj);
                } else if (obj instanceof Date) {
                    obj = serializeDate(obj);
                } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
                    obj = utils.maybeMap(obj, function (value) {
                        if (value instanceof Date) {
                            return serializeDate(value);
                        }
                        return value;
                    });
                }

                if (obj === null) {
                    if (strictNullHandling) {
                        return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
                    }

                    obj = '';
                }

                if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
                    if (encoder) {
                        var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
                        return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
                    }
                    return [formatter(prefix) + '=' + formatter(String(obj))];
                }

                var values = [];

                if (typeof obj === 'undefined') {
                    return values;
                }

                var objKeys;
                if (generateArrayPrefix === 'comma' && isArray(obj)) {
                    // we need to join elements in
                    if (encodeValuesOnly && encoder) {
                        obj = utils.maybeMap(obj, encoder);
                    }
                    objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
                } else if (isArray(filter)) {
                    objKeys = filter;
                } else {
                    var keys = Object.keys(obj);
                    objKeys = sort ? keys.sort(sort) : keys;
                }

                var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

                var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

                if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
                    return adjustedPrefix + '[]';
                }

                for (var j = 0; j < objKeys.length; ++j) {
                    var key = objKeys[j];
                    var value = (typeof key === "undefined" ? "undefined" : _typeof(key)) === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

                    if (skipNulls && value === null) {
                        continue;
                    }

                    var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
                    var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

                    sideChannel.set(object, step);
                    var valueSideChannel = getSideChannel();
                    valueSideChannel.set(sentinel, sideChannel);
                    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
                }

                return values;
            };

            var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
                if (!opts) {
                    return defaults;
                }

                if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
                    throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
                }

                if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
                    throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
                }

                if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
                    throw new TypeError('Encoder has to be a function.');
                }

                var charset = opts.charset || defaults.charset;
                if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
                    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
                }

                var format = formats['default'];
                if (typeof opts.format !== 'undefined') {
                    if (!has.call(formats.formatters, opts.format)) {
                        throw new TypeError('Unknown format option provided.');
                    }
                    format = opts.format;
                }
                var formatter = formats.formatters[format];

                var filter = defaults.filter;
                if (typeof opts.filter === 'function' || isArray(opts.filter)) {
                    filter = opts.filter;
                }

                var arrayFormat;
                if (opts.arrayFormat in arrayPrefixGenerators) {
                    arrayFormat = opts.arrayFormat;
                } else if ('indices' in opts) {
                    arrayFormat = opts.indices ? 'indices' : 'repeat';
                } else {
                    arrayFormat = defaults.arrayFormat;
                }

                if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
                    throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
                }

                var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

                return {
                    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
                    allowDots: allowDots,
                    allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
                    arrayFormat: arrayFormat,
                    charset: charset,
                    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
                    commaRoundTrip: opts.commaRoundTrip,
                    delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
                    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
                    encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
                    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
                    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
                    filter: filter,
                    format: format,
                    formatter: formatter,
                    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
                    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
                    sort: typeof opts.sort === 'function' ? opts.sort : null,
                    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
                };
            };

            module.exports = function (object, opts) {
                var obj = object;
                var options = normalizeStringifyOptions(opts);

                var objKeys;
                var filter;

                if (typeof options.filter === 'function') {
                    filter = options.filter;
                    obj = filter('', obj);
                } else if (isArray(options.filter)) {
                    filter = options.filter;
                    objKeys = filter;
                }

                var keys = [];

                if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== 'object' || obj === null) {
                    return '';
                }

                var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
                var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

                if (!objKeys) {
                    objKeys = Object.keys(obj);
                }

                if (options.sort) {
                    objKeys.sort(options.sort);
                }

                var sideChannel = getSideChannel();
                for (var i = 0; i < objKeys.length; ++i) {
                    var key = objKeys[i];

                    if (options.skipNulls && obj[key] === null) {
                        continue;
                    }
                    pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
                }

                var joined = keys.join(options.delimiter);
                var prefix = options.addQueryPrefix === true ? '?' : '';

                if (options.charsetSentinel) {
                    if (options.charset === 'iso-8859-1') {
                        // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
                        prefix += 'utf8=%26%2310003%3B&';
                    } else {
                        // encodeURIComponent('✓')
                        prefix += 'utf8=%E2%9C%93&';
                    }
                }

                return joined.length > 0 ? prefix + joined : '';
            };
        }, { "./formats": 24, "./utils": 28, "side-channel": 30 }], 28: [function (require, module, exports) {
            'use strict';

            var formats = require('./formats');

            var has = Object.prototype.hasOwnProperty;
            var isArray = Array.isArray;

            var hexTable = function () {
                var array = [];
                for (var i = 0; i < 256; ++i) {
                    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
                }

                return array;
            }();

            var compactQueue = function compactQueue(queue) {
                while (queue.length > 1) {
                    var item = queue.pop();
                    var obj = item.obj[item.prop];

                    if (isArray(obj)) {
                        var compacted = [];

                        for (var j = 0; j < obj.length; ++j) {
                            if (typeof obj[j] !== 'undefined') {
                                compacted.push(obj[j]);
                            }
                        }

                        item.obj[item.prop] = compacted;
                    }
                }
            };

            var arrayToObject = function arrayToObject(source, options) {
                var obj = options && options.plainObjects ? Object.create(null) : {};
                for (var i = 0; i < source.length; ++i) {
                    if (typeof source[i] !== 'undefined') {
                        obj[i] = source[i];
                    }
                }

                return obj;
            };

            var merge = function merge(target, source, options) {
                /* eslint no-param-reassign: 0 */
                if (!source) {
                    return target;
                }

                if ((typeof source === "undefined" ? "undefined" : _typeof(source)) !== 'object') {
                    if (isArray(target)) {
                        target.push(source);
                    } else if (target && (typeof target === "undefined" ? "undefined" : _typeof(target)) === 'object') {
                        if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
                            target[source] = true;
                        }
                    } else {
                        return [target, source];
                    }

                    return target;
                }

                if (!target || (typeof target === "undefined" ? "undefined" : _typeof(target)) !== 'object') {
                    return [target].concat(source);
                }

                var mergeTarget = target;
                if (isArray(target) && !isArray(source)) {
                    mergeTarget = arrayToObject(target, options);
                }

                if (isArray(target) && isArray(source)) {
                    source.forEach(function (item, i) {
                        if (has.call(target, i)) {
                            var targetItem = target[i];
                            if (targetItem && (typeof targetItem === "undefined" ? "undefined" : _typeof(targetItem)) === 'object' && item && (typeof item === "undefined" ? "undefined" : _typeof(item)) === 'object') {
                                target[i] = merge(targetItem, item, options);
                            } else {
                                target.push(item);
                            }
                        } else {
                            target[i] = item;
                        }
                    });
                    return target;
                }

                return Object.keys(source).reduce(function (acc, key) {
                    var value = source[key];

                    if (has.call(acc, key)) {
                        acc[key] = merge(acc[key], value, options);
                    } else {
                        acc[key] = value;
                    }
                    return acc;
                }, mergeTarget);
            };

            var assign = function assignSingleSource(target, source) {
                return Object.keys(source).reduce(function (acc, key) {
                    acc[key] = source[key];
                    return acc;
                }, target);
            };

            var decode = function decode(str, decoder, charset) {
                var strWithoutPlus = str.replace(/\+/g, ' ');
                if (charset === 'iso-8859-1') {
                    // unescape never throws, no try...catch needed:
                    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
                }
                // utf-8
                try {
                    return decodeURIComponent(strWithoutPlus);
                } catch (e) {
                    return strWithoutPlus;
                }
            };

            var limit = 1024;

            /* eslint operator-linebreak: [2, "before"] */

            var encode = function encode(str, defaultEncoder, charset, kind, format) {
                // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
                // It has been adapted here for stricter adherence to RFC 3986
                if (str.length === 0) {
                    return str;
                }

                var string = str;
                if ((typeof str === "undefined" ? "undefined" : _typeof(str)) === 'symbol') {
                    string = Symbol.prototype.toString.call(str);
                } else if (typeof str !== 'string') {
                    string = String(str);
                }

                if (charset === 'iso-8859-1') {
                    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
                        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
                    });
                }

                var out = '';
                for (var j = 0; j < string.length; j += limit) {
                    var segment = string.length >= limit ? string.slice(j, j + limit) : string;
                    var arr = [];

                    for (var i = 0; i < segment.length; ++i) {
                        var c = segment.charCodeAt(i);
                        if (c === 0x2D // -
                        || c === 0x2E // .
                        || c === 0x5F // _
                        || c === 0x7E // ~
                        || c >= 0x30 && c <= 0x39 // 0-9
                        || c >= 0x41 && c <= 0x5A // a-z
                        || c >= 0x61 && c <= 0x7A // A-Z
                        || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
                        ) {
                                arr[arr.length] = segment.charAt(i);
                                continue;
                            }

                        if (c < 0x80) {
                            arr[arr.length] = hexTable[c];
                            continue;
                        }

                        if (c < 0x800) {
                            arr[arr.length] = hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F];
                            continue;
                        }

                        if (c < 0xD800 || c >= 0xE000) {
                            arr[arr.length] = hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
                            continue;
                        }

                        i += 1;
                        c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);

                        arr[arr.length] = hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
                    }

                    out += arr.join('');
                }

                return out;
            };

            var compact = function compact(value) {
                var queue = [{ obj: { o: value }, prop: 'o' }];
                var refs = [];

                for (var i = 0; i < queue.length; ++i) {
                    var item = queue[i];
                    var obj = item.obj[item.prop];

                    var keys = Object.keys(obj);
                    for (var j = 0; j < keys.length; ++j) {
                        var key = keys[j];
                        var val = obj[key];
                        if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === 'object' && val !== null && refs.indexOf(val) === -1) {
                            queue.push({ obj: obj, prop: key });
                            refs.push(val);
                        }
                    }
                }

                compactQueue(queue);

                return value;
            };

            var isRegExp = function isRegExp(obj) {
                return Object.prototype.toString.call(obj) === '[object RegExp]';
            };

            var isBuffer = function isBuffer(obj) {
                if (!obj || (typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== 'object') {
                    return false;
                }

                return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
            };

            var combine = function combine(a, b) {
                return [].concat(a, b);
            };

            var maybeMap = function maybeMap(val, fn) {
                if (isArray(val)) {
                    var mapped = [];
                    for (var i = 0; i < val.length; i += 1) {
                        mapped.push(fn(val[i]));
                    }
                    return mapped;
                }
                return fn(val);
            };

            module.exports = {
                arrayToObject: arrayToObject,
                assign: assign,
                combine: combine,
                compact: compact,
                decode: decode,
                encode: encode,
                isBuffer: isBuffer,
                isRegExp: isRegExp,
                maybeMap: maybeMap,
                merge: merge
            };
        }, { "./formats": 24 }], 29: [function (require, module, exports) {
            'use strict';

            var GetIntrinsic = require('get-intrinsic');
            var define = require('define-data-property');
            var hasDescriptors = require('has-property-descriptors')();
            var gOPD = require('gopd');

            var $TypeError = require('es-errors/type');
            var $floor = GetIntrinsic('%Math.floor%');

            /** @type {import('.')} */
            module.exports = function setFunctionLength(fn, length) {
                if (typeof fn !== 'function') {
                    throw new $TypeError('`fn` is not a function');
                }
                if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
                    throw new $TypeError('`length` must be a positive 32-bit integer');
                }

                var loose = arguments.length > 2 && !!arguments[2];

                var functionLengthIsConfigurable = true;
                var functionLengthIsWritable = true;
                if ('length' in fn && gOPD) {
                    var desc = gOPD(fn, 'length');
                    if (desc && !desc.configurable) {
                        functionLengthIsConfigurable = false;
                    }
                    if (desc && !desc.writable) {
                        functionLengthIsWritable = false;
                    }
                }

                if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
                    if (hasDescriptors) {
                        define( /** @type {Parameters<define>[0]} */fn, 'length', length, true, true);
                    } else {
                        define( /** @type {Parameters<define>[0]} */fn, 'length', length);
                    }
                }
                return fn;
            };
        }, { "define-data-property": 4, "es-errors/type": 11, "get-intrinsic": 15, "gopd": 16, "has-property-descriptors": 17 }], 30: [function (require, module, exports) {
            'use strict';

            var GetIntrinsic = require('get-intrinsic');
            var callBound = require('call-bind/callBound');
            var inspect = require('object-inspect');

            var $TypeError = require('es-errors/type');
            var $WeakMap = GetIntrinsic('%WeakMap%', true);
            var $Map = GetIntrinsic('%Map%', true);

            var $weakMapGet = callBound('WeakMap.prototype.get', true);
            var $weakMapSet = callBound('WeakMap.prototype.set', true);
            var $weakMapHas = callBound('WeakMap.prototype.has', true);
            var $mapGet = callBound('Map.prototype.get', true);
            var $mapSet = callBound('Map.prototype.set', true);
            var $mapHas = callBound('Map.prototype.has', true);

            /*
            * This function traverses the list returning the node corresponding to the given key.
            *
            * That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
            */
            /** @type {import('.').listGetNode} */
            var listGetNode = function listGetNode(list, key) {
                // eslint-disable-line consistent-return
                /** @type {typeof list | NonNullable<(typeof list)['next']>} */
                var prev = list;
                /** @type {(typeof list)['next']} */
                var curr;
                for (; (curr = prev.next) !== null; prev = curr) {
                    if (curr.key === key) {
                        prev.next = curr.next;
                        // eslint-disable-next-line no-extra-parens
                        curr.next = /** @type {NonNullable<typeof list.next>} */list.next;
                        list.next = curr; // eslint-disable-line no-param-reassign
                        return curr;
                    }
                }
            };

            /** @type {import('.').listGet} */
            var listGet = function listGet(objects, key) {
                var node = listGetNode(objects, key);
                return node && node.value;
            };
            /** @type {import('.').listSet} */
            var listSet = function listSet(objects, key, value) {
                var node = listGetNode(objects, key);
                if (node) {
                    node.value = value;
                } else {
                    // Prepend the new node to the beginning of the list
                    objects.next = /** @type {import('.').ListNode<typeof value>} */{ // eslint-disable-line no-param-reassign, no-extra-parens
                        key: key,
                        next: objects.next,
                        value: value
                    };
                }
            };
            /** @type {import('.').listHas} */
            var listHas = function listHas(objects, key) {
                return !!listGetNode(objects, key);
            };

            /** @type {import('.')} */
            module.exports = function getSideChannel() {
                /** @type {WeakMap<object, unknown>} */var $wm;
                /** @type {Map<object, unknown>} */var $m;
                /** @type {import('.').RootNode<unknown>} */var $o;

                /** @type {import('.').Channel} */
                var channel = {
                    assert: function assert(key) {
                        if (!channel.has(key)) {
                            throw new $TypeError('Side channel does not contain ' + inspect(key));
                        }
                    },
                    get: function get(key) {
                        // eslint-disable-line consistent-return
                        if ($WeakMap && key && ((typeof key === "undefined" ? "undefined" : _typeof(key)) === 'object' || typeof key === 'function')) {
                            if ($wm) {
                                return $weakMapGet($wm, key);
                            }
                        } else if ($Map) {
                            if ($m) {
                                return $mapGet($m, key);
                            }
                        } else {
                            if ($o) {
                                // eslint-disable-line no-lonely-if
                                return listGet($o, key);
                            }
                        }
                    },
                    has: function has(key) {
                        if ($WeakMap && key && ((typeof key === "undefined" ? "undefined" : _typeof(key)) === 'object' || typeof key === 'function')) {
                            if ($wm) {
                                return $weakMapHas($wm, key);
                            }
                        } else if ($Map) {
                            if ($m) {
                                return $mapHas($m, key);
                            }
                        } else {
                            if ($o) {
                                // eslint-disable-line no-lonely-if
                                return listHas($o, key);
                            }
                        }
                        return false;
                    },
                    set: function set(key, value) {
                        if ($WeakMap && key && ((typeof key === "undefined" ? "undefined" : _typeof(key)) === 'object' || typeof key === 'function')) {
                            if (!$wm) {
                                $wm = new $WeakMap();
                            }
                            $weakMapSet($wm, key, value);
                        } else if ($Map) {
                            if (!$m) {
                                $m = new $Map();
                            }
                            $mapSet($m, key, value);
                        } else {
                            if (!$o) {
                                // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                                $o = { key: {}, next: null };
                            }
                            listSet($o, key, value);
                        }
                    }
                };
                return channel;
            };
        }, { "call-bind/callBound": 2, "es-errors/type": 11, "get-intrinsic": 15, "object-inspect": 22 }], 31: [function (require, module, exports) {
            /*
             * Copyright Joyent, Inc. and other Node contributors.
             *
             * Permission is hereby granted, free of charge, to any person obtaining a
             * copy of this software and associated documentation files (the
             * "Software"), to deal in the Software without restriction, including
             * without limitation the rights to use, copy, modify, merge, publish,
             * distribute, sublicense, and/or sell copies of the Software, and to permit
             * persons to whom the Software is furnished to do so, subject to the
             * following conditions:
             *
             * The above copyright notice and this permission notice shall be included
             * in all copies or substantial portions of the Software.
             *
             * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
             * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
             * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
             * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
             * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
             * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
             * USE OR OTHER DEALINGS IN THE SOFTWARE.
             */

            'use strict';

            var punycode = require('punycode/');

            function Url() {
                this.protocol = null;
                this.slashes = null;
                this.auth = null;
                this.host = null;
                this.port = null;
                this.hostname = null;
                this.hash = null;
                this.search = null;
                this.query = null;
                this.pathname = null;
                this.path = null;
                this.href = null;
            }

            // Reference: RFC 3986, RFC 1808, RFC 2396

            /*
             * define these here so at least they only have to be
             * compiled once on the first module load.
             */
            var protocolPattern = /^([a-z0-9.+-]+:)/i,
                portPattern = /:[0-9]*$/,


            // Special case for a simple path URL
            simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,


            /*
             * RFC 2396: characters reserved for delimiting URLs.
             * We actually just auto-escape these.
             */
            delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],


            // RFC 2396: characters not allowed for various reasons.
            unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),


            // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
            autoEscape = ['\''].concat(unwise),

            /*
             * Characters that are never ever allowed in a hostname.
             * Note that any invalid chars are also handled, but these
             * are the ones that are *expected* to be seen, so we fast-path
             * them.
             */
            nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
                hostEndingChars = ['/', '?', '#'],
                hostnameMaxLen = 255,
                hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
                hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,

            // protocols that can allow "unsafe" and "unwise" chars.
            unsafeProtocol = {
                javascript: true,
                'javascript:': true
            },

            // protocols that never have a hostname.
            hostlessProtocol = {
                javascript: true,
                'javascript:': true
            },

            // protocols that always contain a // bit.
            slashedProtocol = {
                http: true,
                https: true,
                ftp: true,
                gopher: true,
                file: true,
                'http:': true,
                'https:': true,
                'ftp:': true,
                'gopher:': true,
                'file:': true
            },
                querystring = require('qs');

            function urlParse(url, parseQueryString, slashesDenoteHost) {
                if (url && (typeof url === "undefined" ? "undefined" : _typeof(url)) === 'object' && url instanceof Url) {
                    return url;
                }

                var u = new Url();
                u.parse(url, parseQueryString, slashesDenoteHost);
                return u;
            }

            Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
                if (typeof url !== 'string') {
                    throw new TypeError("Parameter 'url' must be a string, not " + (typeof url === "undefined" ? "undefined" : _typeof(url)));
                }

                /*
                 * Copy chrome, IE, opera backslash-handling behavior.
                 * Back slashes before the query string get converted to forward slashes
                 * See: https://code.google.com/p/chromium/issues/detail?id=25916
                 */
                var queryIndex = url.indexOf('?'),
                    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
                    uSplit = url.split(splitter),
                    slashRegex = /\\/g;
                uSplit[0] = uSplit[0].replace(slashRegex, '/');
                url = uSplit.join(splitter);

                var rest = url;

                /*
                 * trim before proceeding.
                 * This is to support parse stuff like "  http://foo.com  \n"
                 */
                rest = rest.trim();

                if (!slashesDenoteHost && url.split('#').length === 1) {
                    // Try fast path regexp
                    var simplePath = simplePathPattern.exec(rest);
                    if (simplePath) {
                        this.path = rest;
                        this.href = rest;
                        this.pathname = simplePath[1];
                        if (simplePath[2]) {
                            this.search = simplePath[2];
                            if (parseQueryString) {
                                this.query = querystring.parse(this.search.substr(1));
                            } else {
                                this.query = this.search.substr(1);
                            }
                        } else if (parseQueryString) {
                            this.search = '';
                            this.query = {};
                        }
                        return this;
                    }
                }

                var proto = protocolPattern.exec(rest);
                if (proto) {
                    proto = proto[0];
                    var lowerProto = proto.toLowerCase();
                    this.protocol = lowerProto;
                    rest = rest.substr(proto.length);
                }

                /*
                 * figure out if it's got a host
                 * user@server is *always* interpreted as a hostname, and url
                 * resolution will treat //foo/bar as host=foo,path=bar because that's
                 * how the browser resolves relative URLs.
                 */
                if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
                    var slashes = rest.substr(0, 2) === '//';
                    if (slashes && !(proto && hostlessProtocol[proto])) {
                        rest = rest.substr(2);
                        this.slashes = true;
                    }
                }

                if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {

                    /*
                     * there's a hostname.
                     * the first instance of /, ?, ;, or # ends the host.
                     *
                     * If there is an @ in the hostname, then non-host chars *are* allowed
                     * to the left of the last @ sign, unless some host-ending character
                     * comes *before* the @-sign.
                     * URLs are obnoxious.
                     *
                     * ex:
                     * http://a@b@c/ => user:a@b host:c
                     * http://a@b?@c => user:a host:c path:/?@c
                     */

                    /*
                     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
                     * Review our test case against browsers more comprehensively.
                     */

                    // find the first instance of any hostEndingChars
                    var hostEnd = -1;
                    for (var i = 0; i < hostEndingChars.length; i++) {
                        var hec = rest.indexOf(hostEndingChars[i]);
                        if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
                            hostEnd = hec;
                        }
                    }

                    /*
                     * at this point, either we have an explicit point where the
                     * auth portion cannot go past, or the last @ char is the decider.
                     */
                    var auth, atSign;
                    if (hostEnd === -1) {
                        // atSign can be anywhere.
                        atSign = rest.lastIndexOf('@');
                    } else {
                        /*
                         * atSign must be in auth portion.
                         * http://a@b/c@d => host:b auth:a path:/c@d
                         */
                        atSign = rest.lastIndexOf('@', hostEnd);
                    }

                    /*
                     * Now we have a portion which is definitely the auth.
                     * Pull that off.
                     */
                    if (atSign !== -1) {
                        auth = rest.slice(0, atSign);
                        rest = rest.slice(atSign + 1);
                        this.auth = decodeURIComponent(auth);
                    }

                    // the host is the remaining to the left of the first non-host char
                    hostEnd = -1;
                    for (var i = 0; i < nonHostChars.length; i++) {
                        var hec = rest.indexOf(nonHostChars[i]);
                        if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
                            hostEnd = hec;
                        }
                    }
                    // if we still have not hit it, then the entire thing is a host.
                    if (hostEnd === -1) {
                        hostEnd = rest.length;
                    }

                    this.host = rest.slice(0, hostEnd);
                    rest = rest.slice(hostEnd);

                    // pull out port.
                    this.parseHost();

                    /*
                     * we've indicated that there is a hostname,
                     * so even if it's empty, it has to be present.
                     */
                    this.hostname = this.hostname || '';

                    /*
                     * if hostname begins with [ and ends with ]
                     * assume that it's an IPv6 address.
                     */
                    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

                    // validate a little.
                    if (!ipv6Hostname) {
                        var hostparts = this.hostname.split(/\./);
                        for (var i = 0, l = hostparts.length; i < l; i++) {
                            var part = hostparts[i];
                            if (!part) {
                                continue;
                            }
                            if (!part.match(hostnamePartPattern)) {
                                var newpart = '';
                                for (var j = 0, k = part.length; j < k; j++) {
                                    if (part.charCodeAt(j) > 127) {
                                        /*
                                         * we replace non-ASCII char with a temporary placeholder
                                         * we need this to make sure size of hostname is not
                                         * broken by replacing non-ASCII by nothing
                                         */
                                        newpart += 'x';
                                    } else {
                                        newpart += part[j];
                                    }
                                }
                                // we test again with ASCII char only
                                if (!newpart.match(hostnamePartPattern)) {
                                    var validParts = hostparts.slice(0, i);
                                    var notHost = hostparts.slice(i + 1);
                                    var bit = part.match(hostnamePartStart);
                                    if (bit) {
                                        validParts.push(bit[1]);
                                        notHost.unshift(bit[2]);
                                    }
                                    if (notHost.length) {
                                        rest = '/' + notHost.join('.') + rest;
                                    }
                                    this.hostname = validParts.join('.');
                                    break;
                                }
                            }
                        }
                    }

                    if (this.hostname.length > hostnameMaxLen) {
                        this.hostname = '';
                    } else {
                        // hostnames are always lower case.
                        this.hostname = this.hostname.toLowerCase();
                    }

                    if (!ipv6Hostname) {
                        /*
                         * IDNA Support: Returns a punycoded representation of "domain".
                         * It only converts parts of the domain name that
                         * have non-ASCII characters, i.e. it doesn't matter if
                         * you call it with a domain that already is ASCII-only.
                         */
                        this.hostname = punycode.toASCII(this.hostname);
                    }

                    var p = this.port ? ':' + this.port : '';
                    var h = this.hostname || '';
                    this.host = h + p;
                    this.href += this.host;

                    /*
                     * strip [ and ] from the hostname
                     * the host field still retains them, though
                     */
                    if (ipv6Hostname) {
                        this.hostname = this.hostname.substr(1, this.hostname.length - 2);
                        if (rest[0] !== '/') {
                            rest = '/' + rest;
                        }
                    }
                }

                /*
                 * now rest is set to the post-host stuff.
                 * chop off any delim chars.
                 */
                if (!unsafeProtocol[lowerProto]) {

                    /*
                     * First, make 100% sure that any "autoEscape" chars get
                     * escaped, even if encodeURIComponent doesn't think they
                     * need to be.
                     */
                    for (var i = 0, l = autoEscape.length; i < l; i++) {
                        var ae = autoEscape[i];
                        if (rest.indexOf(ae) === -1) {
                            continue;
                        }
                        var esc = encodeURIComponent(ae);
                        if (esc === ae) {
                            esc = escape(ae);
                        }
                        rest = rest.split(ae).join(esc);
                    }
                }

                // chop off from the tail first.
                var hash = rest.indexOf('#');
                if (hash !== -1) {
                    // got a fragment string.
                    this.hash = rest.substr(hash);
                    rest = rest.slice(0, hash);
                }
                var qm = rest.indexOf('?');
                if (qm !== -1) {
                    this.search = rest.substr(qm);
                    this.query = rest.substr(qm + 1);
                    if (parseQueryString) {
                        this.query = querystring.parse(this.query);
                    }
                    rest = rest.slice(0, qm);
                } else if (parseQueryString) {
                    // no query string, but parseQueryString still requested
                    this.search = '';
                    this.query = {};
                }
                if (rest) {
                    this.pathname = rest;
                }
                if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
                    this.pathname = '/';
                }

                // to support http.request
                if (this.pathname || this.search) {
                    var p = this.pathname || '';
                    var s = this.search || '';
                    this.path = p + s;
                }

                // finally, reconstruct the href based on what has been validated.
                this.href = this.format();
                return this;
            };

            // format a parsed object into a url string
            function urlFormat(obj) {
                /*
                 * ensure it's an object, and not a string url.
                 * If it's an obj, this is a no-op.
                 * this way, you can call url_format() on strings
                 * to clean up potentially wonky urls.
                 */
                if (typeof obj === 'string') {
                    obj = urlParse(obj);
                }
                if (!(obj instanceof Url)) {
                    return Url.prototype.format.call(obj);
                }
                return obj.format();
            }

            Url.prototype.format = function () {
                var auth = this.auth || '';
                if (auth) {
                    auth = encodeURIComponent(auth);
                    auth = auth.replace(/%3A/i, ':');
                    auth += '@';
                }

                var protocol = this.protocol || '',
                    pathname = this.pathname || '',
                    hash = this.hash || '',
                    host = false,
                    query = '';

                if (this.host) {
                    host = auth + this.host;
                } else if (this.hostname) {
                    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
                    if (this.port) {
                        host += ':' + this.port;
                    }
                }

                if (this.query && _typeof(this.query) === 'object' && Object.keys(this.query).length) {
                    query = querystring.stringify(this.query, {
                        arrayFormat: 'repeat',
                        addQueryPrefix: false
                    });
                }

                var search = this.search || query && '?' + query || '';

                if (protocol && protocol.substr(-1) !== ':') {
                    protocol += ':';
                }

                /*
                 * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
                 * unless they had them to begin with.
                 */
                if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
                    host = '//' + (host || '');
                    if (pathname && pathname.charAt(0) !== '/') {
                        pathname = '/' + pathname;
                    }
                } else if (!host) {
                    host = '';
                }

                if (hash && hash.charAt(0) !== '#') {
                    hash = '#' + hash;
                }
                if (search && search.charAt(0) !== '?') {
                    search = '?' + search;
                }

                pathname = pathname.replace(/[?#]/g, function (match) {
                    return encodeURIComponent(match);
                });
                search = search.replace('#', '%23');

                return protocol + host + pathname + search + hash;
            };

            function urlResolve(source, relative) {
                return urlParse(source, false, true).resolve(relative);
            }

            Url.prototype.resolve = function (relative) {
                return this.resolveObject(urlParse(relative, false, true)).format();
            };

            function urlResolveObject(source, relative) {
                if (!source) {
                    return relative;
                }
                return urlParse(source, false, true).resolveObject(relative);
            }

            Url.prototype.resolveObject = function (relative) {
                if (typeof relative === 'string') {
                    var rel = new Url();
                    rel.parse(relative, false, true);
                    relative = rel;
                }

                var result = new Url();
                var tkeys = Object.keys(this);
                for (var tk = 0; tk < tkeys.length; tk++) {
                    var tkey = tkeys[tk];
                    result[tkey] = this[tkey];
                }

                /*
                 * hash is always overridden, no matter what.
                 * even href="" will remove it.
                 */
                result.hash = relative.hash;

                // if the relative url is empty, then there's nothing left to do here.
                if (relative.href === '') {
                    result.href = result.format();
                    return result;
                }

                // hrefs like //foo/bar always cut to the protocol.
                if (relative.slashes && !relative.protocol) {
                    // take everything except the protocol from relative
                    var rkeys = Object.keys(relative);
                    for (var rk = 0; rk < rkeys.length; rk++) {
                        var rkey = rkeys[rk];
                        if (rkey !== 'protocol') {
                            result[rkey] = relative[rkey];
                        }
                    }

                    // urlParse appends trailing / to urls like http://www.example.com
                    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
                        result.pathname = '/';
                        result.path = result.pathname;
                    }

                    result.href = result.format();
                    return result;
                }

                if (relative.protocol && relative.protocol !== result.protocol) {
                    /*
                     * if it's a known url protocol, then changing
                     * the protocol does weird things
                     * first, if it's not file:, then we MUST have a host,
                     * and if there was a path
                     * to begin with, then we MUST have a path.
                     * if it is file:, then the host is dropped,
                     * because that's known to be hostless.
                     * anything else is assumed to be absolute.
                     */
                    if (!slashedProtocol[relative.protocol]) {
                        var keys = Object.keys(relative);
                        for (var v = 0; v < keys.length; v++) {
                            var k = keys[v];
                            result[k] = relative[k];
                        }
                        result.href = result.format();
                        return result;
                    }

                    result.protocol = relative.protocol;
                    if (!relative.host && !hostlessProtocol[relative.protocol]) {
                        var relPath = (relative.pathname || '').split('/');
                        while (relPath.length && !(relative.host = relPath.shift())) {}
                        if (!relative.host) {
                            relative.host = '';
                        }
                        if (!relative.hostname) {
                            relative.hostname = '';
                        }
                        if (relPath[0] !== '') {
                            relPath.unshift('');
                        }
                        if (relPath.length < 2) {
                            relPath.unshift('');
                        }
                        result.pathname = relPath.join('/');
                    } else {
                        result.pathname = relative.pathname;
                    }
                    result.search = relative.search;
                    result.query = relative.query;
                    result.host = relative.host || '';
                    result.auth = relative.auth;
                    result.hostname = relative.hostname || relative.host;
                    result.port = relative.port;
                    // to support http.request
                    if (result.pathname || result.search) {
                        var p = result.pathname || '';
                        var s = result.search || '';
                        result.path = p + s;
                    }
                    result.slashes = result.slashes || relative.slashes;
                    result.href = result.format();
                    return result;
                }

                var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
                    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
                    mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
                    removeAllDots = mustEndAbs,
                    srcPath = result.pathname && result.pathname.split('/') || [],
                    relPath = relative.pathname && relative.pathname.split('/') || [],
                    psychotic = result.protocol && !slashedProtocol[result.protocol];

                /*
                 * if the url is a non-slashed url, then relative
                 * links like ../.. should be able
                 * to crawl up to the hostname, as well.  This is strange.
                 * result.protocol has already been set by now.
                 * Later on, put the first path part into the host field.
                 */
                if (psychotic) {
                    result.hostname = '';
                    result.port = null;
                    if (result.host) {
                        if (srcPath[0] === '') {
                            srcPath[0] = result.host;
                        } else {
                            srcPath.unshift(result.host);
                        }
                    }
                    result.host = '';
                    if (relative.protocol) {
                        relative.hostname = null;
                        relative.port = null;
                        if (relative.host) {
                            if (relPath[0] === '') {
                                relPath[0] = relative.host;
                            } else {
                                relPath.unshift(relative.host);
                            }
                        }
                        relative.host = null;
                    }
                    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
                }

                if (isRelAbs) {
                    // it's absolute.
                    result.host = relative.host || relative.host === '' ? relative.host : result.host;
                    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
                    result.search = relative.search;
                    result.query = relative.query;
                    srcPath = relPath;
                    // fall through to the dot-handling below.
                } else if (relPath.length) {
                    /*
                     * it's relative
                     * throw away the existing file, and take the new path instead.
                     */
                    if (!srcPath) {
                        srcPath = [];
                    }
                    srcPath.pop();
                    srcPath = srcPath.concat(relPath);
                    result.search = relative.search;
                    result.query = relative.query;
                } else if (relative.search != null) {
                    /*
                     * just pull out the search.
                     * like href='?foo'.
                     * Put this after the other two cases because it simplifies the booleans
                     */
                    if (psychotic) {
                        result.host = srcPath.shift();
                        result.hostname = result.host;
                        /*
                         * occationaly the auth can get stuck only in host
                         * this especially happens in cases like
                         * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                         */
                        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
                        if (authInHost) {
                            result.auth = authInHost.shift();
                            result.hostname = authInHost.shift();
                            result.host = result.hostname;
                        }
                    }
                    result.search = relative.search;
                    result.query = relative.query;
                    // to support http.request
                    if (result.pathname !== null || result.search !== null) {
                        result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
                    }
                    result.href = result.format();
                    return result;
                }

                if (!srcPath.length) {
                    /*
                     * no path at all.  easy.
                     * we've already handled the other stuff above.
                     */
                    result.pathname = null;
                    // to support http.request
                    if (result.search) {
                        result.path = '/' + result.search;
                    } else {
                        result.path = null;
                    }
                    result.href = result.format();
                    return result;
                }

                /*
                 * if a url ENDs in . or .., then it must get a trailing slash.
                 * however, if it ends in anything else non-slashy,
                 * then it must NOT get a trailing slash.
                 */
                var last = srcPath.slice(-1)[0];
                var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

                /*
                 * strip single dots, resolve double dots to parent dir
                 * if the path tries to go above the root, `up` ends up > 0
                 */
                var up = 0;
                for (var i = srcPath.length; i >= 0; i--) {
                    last = srcPath[i];
                    if (last === '.') {
                        srcPath.splice(i, 1);
                    } else if (last === '..') {
                        srcPath.splice(i, 1);
                        up++;
                    } else if (up) {
                        srcPath.splice(i, 1);
                        up--;
                    }
                }

                // if the path is allowed to go above the root, restore leading ..s
                if (!mustEndAbs && !removeAllDots) {
                    for (; up--; up) {
                        srcPath.unshift('..');
                    }
                }

                if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
                    srcPath.unshift('');
                }

                if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
                    srcPath.push('');
                }

                var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';

                // put the host back
                if (psychotic) {
                    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
                    result.host = result.hostname;
                    /*
                     * occationaly the auth can get stuck only in host
                     * this especially happens in cases like
                     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                     */
                    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
                    if (authInHost) {
                        result.auth = authInHost.shift();
                        result.hostname = authInHost.shift();
                        result.host = result.hostname;
                    }
                }

                mustEndAbs = mustEndAbs || result.host && srcPath.length;

                if (mustEndAbs && !isAbsolute) {
                    srcPath.unshift('');
                }

                if (srcPath.length > 0) {
                    result.pathname = srcPath.join('/');
                } else {
                    result.pathname = null;
                    result.path = null;
                }

                // to support request.http
                if (result.pathname !== null || result.search !== null) {
                    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
                }
                result.auth = relative.auth || result.auth;
                result.slashes = result.slashes || relative.slashes;
                result.href = result.format();
                return result;
            };

            Url.prototype.parseHost = function () {
                var host = this.host;
                var port = portPattern.exec(host);
                if (port) {
                    port = port[0];
                    if (port !== ':') {
                        this.port = port.substr(1);
                    }
                    host = host.substr(0, host.length - port.length);
                }
                if (host) {
                    this.hostname = host;
                }
            };

            exports.parse = urlParse;
            exports.resolve = urlResolve;
            exports.resolveObject = urlResolveObject;
            exports.format = urlFormat;

            exports.Url = Url;
        }, { "punycode/": 23, "qs": 25 }], 32: [function (require, module, exports) {
            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            exports.LinkMapper = void 0;
            var url_1 = require("url");
            var networks = [{
                name: 'Skimlinks',
                default: true,
                requiresAdvertiserDetails: false,
                linkTemplate: function linkTemplate(destinationUrl, publisherId, referringUrl) {
                    return "https://go.skimresources.com?id=" + publisherId + "&xs=1&url=" + destinationUrl + "&sref=" + referringUrl;
                }
            }, {
                name: 'CJ Affiliates',
                requiresAdvertiserDetails: false,
                linkTemplate: function linkTemplate(destinationUrl, publisherId) {
                    return "https://www.anrdoezrs.net/links/" + publisherId + "/type/dlg/" + destinationUrl;
                }
            }, {
                name: 'Digidip',
                requiresAdvertiserDetails: false,
                linkTemplate: function linkTemplate(destinationUrl, publisherId) {
                    return "https://" + publisherId + ".digidip.net/visit?url=" + destinationUrl;
                }
            }, {
                name: 'Rakuten',
                requiresAdvertiserDetails: true,
                linkTemplate: function linkTemplate(destinationUrl, publisherId, advertiserId) {
                    return "https://click.linksynergy.com/deeplink?id=" + publisherId + "&mid=" + advertiserId + "&murl=" + destinationUrl;
                }
            }, {
                name: 'Partnerize',
                requiresAdvertiserDetails: true,
                linkTemplate: function linkTemplate(destinationUrl, campaignId) {
                    return "https://prf.hn/click/camref:" + campaignId + "/destination:" + destinationUrl;
                }
            }, {
                name: 'Awin',
                requiresAdvertiserDetails: true,
                linkTemplate: function linkTemplate(destinationUrl, publisherId, advertiserId) {
                    return "https://www.awin1.com/cread.php?awinmid=" + advertiserId + "&awinaffid=" + publisherId + "&ued=" + destinationUrl;
                }
            }, {
                name: 'Impact',
                requiresAdvertiserDetails: true,
                linkTemplate: function linkTemplate(destinationUrl, deepLink) {
                    return "https://" + deepLink + "?u=" + destinationUrl;
                }
            }, {
                name: 'Kutoku',
                requiresAdvertiserDetails: true,
                linkTemplate: function linkTemplate(destinationUrl, publisherId) {
                    return "https://links.kutoku.com/" + publisherId + "?url=" + destinationUrl + "&contentId=sneakinpeace";
                }
            }];

            var LinkMapper = function () {
                function LinkMapper(networkMappings, rules, AdvertiserDetails, country) {
                    _classCallCheck(this, LinkMapper);

                    // check if a supplied network requires additional details
                    this.rules = rules;
                    this.networkMappings = networkMappings;
                    this.defaultNetwork = networks[0];
                    this.advertisers = AdvertiserDetails;
                    this.country = country;
                }

                _createClass(LinkMapper, [{
                    key: "findPublisherId",
                    value: function findPublisherId(networkName) {
                        var foundMapping = this.networkMappings.find(function (networkMapping) {
                            return networkMapping.network === networkName;
                        });
                        return foundMapping === null || foundMapping === void 0 ? void 0 : foundMapping.publisherId;
                    }
                }, {
                    key: "swapUrlBasedOnCountry",
                    value: function swapUrlBasedOnCountry(url, rule, countryCode) {
                        if (!countryCode) {
                            return url;
                        }
                        if (!rule.regionalUrls) {
                            return url;
                        }
                        var foundRegionalUrl = rule === null || rule === void 0 ? void 0 : rule.regionalUrls.find(function (regionalUrl) {
                            return regionalUrl.country === countryCode;
                        });
                        if (foundRegionalUrl === null || foundRegionalUrl === void 0 ? void 0 : foundRegionalUrl.url) {
                            var parsedRegionalUrl = new url_1.URL(foundRegionalUrl.url);
                            var splitPathRegionalUrl = parsedRegionalUrl.pathname.split("/").filter(function (i) {
                                return i;
                            });
                            var parsedUrl = new url_1.URL(url);
                            var paramsToRemove = splitPathRegionalUrl.length;
                            var splitPath = parsedUrl.pathname.split("/");
                            var withoutDomain = splitPath.splice(paramsToRemove + 1, splitPath.length);
                            return foundRegionalUrl.url + "/" + withoutDomain.join("/");
                        }
                        return url;
                    }
                }, {
                    key: "findMatchingRule",
                    value: function findMatchingRule(url) {
                        var matchingRules = this.rules.filter(function (rule) {
                            if (url.includes(rule.url)) {
                                return true;
                            } else {
                                return false;
                            }
                        });
                        var longestRule = matchingRules[0]; // Start with the first rule as the longest
                        for (var i = 1; i < matchingRules.length; i++) {
                            if (matchingRules[i].url.length > longestRule.url.length) {
                                longestRule = matchingRules[i]; // Update if the current URL is longer
                            }
                        }
                        return longestRule;
                    }
                }, {
                    key: "findMatchingNetwork",
                    value: function findMatchingNetwork(url) {
                        // loop though all urls
                        var matchingRule = this.findMatchingRule(url);
                        if (!matchingRule) {
                            return this.defaultNetwork;
                        }
                        var foundNetwork = networks.find(function (network) {
                            return network.name === matchingRule.network;
                        });
                        return foundNetwork || this.defaultNetwork;
                    }
                }, {
                    key: "findAdvertiserInfo",
                    value: function findAdvertiserInfo(url) {
                        if (!this.advertisers) {
                            return null;
                        }
                        var matchingAdvertisers = this.advertisers.filter(function (advertiser) {
                            if (url.includes(advertiser.url)) {
                                return true;
                            } else {
                                return false;
                            }
                        });
                        var matchingAdvertiserWithLongestUrl = matchingAdvertisers.reduce(function (longest, current) {
                            return current.url.length > longest.url.length ? current : longest;
                        }, matchingAdvertisers[0]);
                        return matchingAdvertiserWithLongestUrl;
                    }
                }, {
                    key: "linkBuilder",
                    value: function linkBuilder(network, destinationUrl, referringUrl) {
                        var affiliateLink = '';
                        var publisherId = void 0;
                        var advertiserInfo = void 0;
                        switch (network.name) {
                            case 'Rakuten':
                                publisherId = this.findPublisherId(network.name);
                                advertiserInfo = this.findAdvertiserInfo(destinationUrl);
                                if (advertiserInfo) {
                                    affiliateLink = network.linkTemplate(destinationUrl, publisherId, advertiserInfo.id);
                                    break;
                                }
                            case 'Awin':
                                publisherId = this.findPublisherId(network.name);
                                advertiserInfo = this.findAdvertiserInfo(destinationUrl);
                                if (advertiserInfo) {
                                    affiliateLink = network.linkTemplate(destinationUrl, publisherId, advertiserInfo.id);
                                    break;
                                }
                            case 'Digidip':
                                publisherId = this.findPublisherId(network.name);
                                affiliateLink = network.linkTemplate(destinationUrl, publisherId);
                                break;
                            case 'CJ Affiliates':
                                publisherId = this.findPublisherId(network.name);
                                affiliateLink = network.linkTemplate(destinationUrl, publisherId);
                                break;
                            case 'Partnerize':
                                advertiserInfo = this.findAdvertiserInfo(destinationUrl);
                                if (advertiserInfo) {
                                    affiliateLink = network.linkTemplate(destinationUrl, advertiserInfo.id);
                                    break;
                                }
                            case 'Impact':
                                advertiserInfo = this.findAdvertiserInfo(destinationUrl);
                                if (advertiserInfo) {
                                    affiliateLink = network.linkTemplate(destinationUrl, advertiserInfo.id);
                                    break;
                                }
                            default:
                                publisherId = this.findPublisherId(network.name);
                                affiliateLink = network.linkTemplate(destinationUrl, publisherId, referringUrl);
                                break;
                        }
                        return affiliateLink;
                    }
                }, {
                    key: "convertToAffiliateLink",
                    value: function convertToAffiliateLink(destinationUrl, referringUrl) {
                        var matchingRule = this.findMatchingRule(destinationUrl);
                        var matchingNetwork = this.findMatchingNetwork(destinationUrl);
                        // if country defined
                        // try swapping out to know country. Fallback to unchanged url
                        var geoSpecifcDestinationUrl = this.swapUrlBasedOnCountry(destinationUrl, matchingRule, this.country);
                        return this.linkBuilder(matchingNetwork, geoSpecifcDestinationUrl, referringUrl);
                    }
                }]);

                return LinkMapper;
            }();

            exports.LinkMapper = LinkMapper;
        }, { "url": 31 }] }, {}, [32])(32);
});